/* 做题操作台（/practice/）：整卷连续作答，原地切题、常驻答题卡与计时、交卷即出报告。
 * 数据：GET /api/paper?<location.search>[&x=<#x=slug>] 一次返回整卷（题目+答案+解析）。
 * 「练相似题」的来源题 slug 放 fragment #x=<slug>（fragment 不发服务器、爬虫按无 fragment URL 去重，docs/plan-r550），取卷时拼回 &x=。
 * 会话：sessionStorage tiku-ws:<search><#x=slug> 存 {i,ans,start,end,submitted,payload?}（随机卷把 payload 一并存，刷新不换卷）。
 * 记分口径与 app.js 一致：tiku-done/wrong/fav 存 "/q/<slug>/"，tiku-stats {a,c}，tiku-days / tiku-dayok 按日作答数 / 答对数；
 * 背题模式/先看解析不计分。改动本文件需递增 layout.ts 的 PJS_VER。 */
(function () {
  'use strict';

  var root = document.getElementById('ws'); if (!root) return;
  var store = {
    read: function (k, def) {
      try { return JSON.parse(localStorage.getItem(k) || def); }
      catch (_) { try { localStorage.removeItem(k); } catch (__) { /* noop */ } return JSON.parse(def); }
    },
    readList: function (k) { return store.read(k, '[]'); },
    write: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (_) { /* noop */ } }
  };
  var QTYPE = { single_choice: '单选题', multi_choice: '多选题', true_false: '判断题', material: '材料题' };
  function stars(d) { var f = Math.max(1, Math.min(5, d || 1)); return '★'.repeat(f) + '☆'.repeat(5 - f); }
  function localDay(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  /* 移除操作行一项（控件 + 项内分隔符）；若它是末项，前一项的尾分隔符一并去掉 */
  function removeAct(ctrl) {
    var it = ctrl.closest('.js-act');
    if (!it) { ctrl.remove(); return; }
    var prev = it.previousElementSibling;
    if (!it.nextElementSibling && prev && prev.lastElementChild && prev.lastElementChild.getAttribute('aria-hidden') === 'true') prev.lastElementChild.remove();
    it.remove();
  }
  /* 固定卷续练目标：从题目 kps[].href 解析 (exam, subject)，优先取答错/未答题里出现最多的科目，全对时取全卷 */
  function smartHrefFor(all, wrongList, line) {
    function pick(list) {
      var cnt = {}; var best = '';
      (list || []).forEach(function (q) {
        (q.kps || []).forEach(function (k) {
          var m = /^\/kaoshi\/([\w-]+)\/([\w-]+)\/kp\//.exec(k.href || '');
          if (!m) return;
          var key = m[1] + '/' + m[2];
          cnt[key] = (cnt[key] || 0) + 1;
          if (!best || cnt[key] > cnt[best]) best = key;
        });
      });
      return best;
    }
    var key = pick(wrongList) || pick(all);
    if (!key) return '';
    var n = store.read('tiku-n', '10');
    if ([5, 10, 15, 20].indexOf(n) < 0) n = 10;
    var p = key.split('/');
    return '/practice/?mode=smart&exam=' + encodeURIComponent(p[0]) + '&subject=' + encodeURIComponent(p[1]) + (line ? '&line=1' : '') + '&n=' + n;
  }
  /* 材料正文：文字段落保留换行；连续 ≥2 竖线的行渲染为真表格（与服务端 parseMaterial 同规则，DOM 构造不走 innerHTML） */
  function matBlocks(text) {
    var out = [], para = [], rows = [];
    var numeric = /^[-+−]?[\d,，]+(\.\d+)?\s*%?$/;
    function flushPara() {
      var t = para.join('\n').replace(/^\n+|\n+$/g, '');
      if (t) out.push(el('p', 'whitespace-pre-wrap', t));
      para = [];
    }
    function flushRows() {
      if (!rows.length) return;
      var wrap = el('div', 'qz-tbl my-2 overflow-x-auto'), table = el('table');
      wrap.setAttribute('tabindex', '0'); wrap.setAttribute('role', 'group'); wrap.setAttribute('aria-label', '材料表格');
      rows.forEach(function (cells, i) {
        var tr = el('tr');
        cells.forEach(function (c) { tr.appendChild(el(i ? 'td' : 'th', numeric.test(c) ? 'text-right' : 'text-left', c)); });
        table.appendChild(el(i ? 'tbody' : 'thead')).appendChild(tr);
      });
      wrap.appendChild(table); out.push(wrap); rows = [];
    }
    String(text).split('\n').forEach(function (line) {
      var cells = null;
      if (line.split('|').length > 2) {
        var s = line.trim();
        if (s.charAt(0) === '|') s = s.slice(1);
        if (s.charAt(s.length - 1) === '|') s = s.slice(0, -1);
        cells = s.split('|').map(function (c) { return c.trim(); });
        if (cells.length < 2) cells = null;
      }
      if (cells) {
        if (/^[\s|:\-—]+$/.test(line)) return;
        if (!rows.length) flushPara();
        rows.push(cells);
      } else {
        if (rows.length) flushRows();
        para.push(line);
      }
    });
    flushRows(); flushPara();
    return out;
  }
  var CHECK = '<svg class="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/></svg>';
  var CROSS = '<svg class="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg>';

  /* 错因标注：契约与 app.js 一致，tiku-wrongr 存 {slug:code}，点选高亮、再点取消 */
  var REASONS = [['cx', '粗心大意'], ['st', '审题不清'], ['zs', '知识模糊'], ['js', '计算失误']];
  function reasonRow(slug) {
    var row = el('div', 'js-reason-row flex flex-wrap items-center gap-1.5 rounded-b-xl border border-t-0 border-line bg-white px-4 py-2 text-[12px]');
    row.appendChild(el('span', 'text-muted', '错因'));
    function render() {
      while (row.children.length > 1) row.removeChild(row.lastChild);
      var cur = store.read('tiku-wrongr', '{}')[slug] || '';
      REASONS.forEach(function (r) {
        var b = el('button', cur === r[0]
          ? 'tap-y rounded-full bg-brand-700 px-2.5 py-0.5 font-medium text-white'
          : 'tap-y rounded-full border border-line bg-slate-50 px-2.5 py-0.5 text-slate-600 hover:bg-brand-50', r[1]);
        b.type = 'button';
        b.addEventListener('click', function () {
          var wr = store.read('tiku-wrongr', '{}');
          if (wr[slug] === r[0]) { delete wr[slug]; } else { wr[slug] = r[0]; }
          store.write('tiku-wrongr', wr);
          render();
        });
        row.appendChild(b);
      });
    }
    render();
    return row;
  }

  var HX = /^#x=([\w-]{1,80})$/.exec(location.hash);
  var HXS = HX ? '#x=' + HX[1] : '';
  var PQ = location.search + (HX ? (location.search ? '&' : '?') + 'x=' + HX[1] : '');
  var SKEY = 'tiku-ws:' + location.search + HXS;
  /* fragment 是会话键的一部分：同文档只换 #x=（复盘卡换来源题）浏览器不重新加载，须整页重载才会取新卷 */
  addEventListener('hashchange', function () { location.reload(); });
  var meta = null; var qs = [];
  /* ans[i] = {picked:[], done:bool, ok:bool|null, viewed:bool} */
  /* qt[i] = 第 i 题累计停留毫秒（暂停不计），随会话持久化 */
  var ws = { i: 0, ans: [], mk: [], ex: [], start: Date.now(), end: 0, submitted: false, po: 0, pa: 0, qt: [], cb: 0, cbm: 0, to: 0 };
  var browse = store.read('tiku-browse', 'null') === 1;
  /* 限时卷（模考）：固定交卷后统一判分、背题模式不生效——作答中不露对错，成绩与榜单才可比 */
  function timed() { return ws.end > 0; }
  function browseOn() { return browse && !timed(); }
  var defer = store.read('tiku-defer', 'null') === 1;
  var autoNext = store.read('tiku-auto', 'null') === 1;
  var optShuf = store.read('tiku-shufopt', 'null') === 1;
  var fontLv = store.read('tiku-font', 'null');
  if (fontLv !== 1 && fontLv !== 2) fontLv = 0;
  var darkPref = store.read('tiku-dark', 'null');
  var darkOn = darkPref === 1 || (darkPref !== 0 && matchMedia('(prefers-color-scheme: dark)').matches);
  var $ = function (id) { return document.getElementById(id); };

  /* 报告「累计」口径的 /api/kpmap 在开卷时预取：交卷/恢复报告时同步渲染考点行，不再异步补行造成位移 */
  var kpmapData = null; var kpmapP = null;
  /* line：蓝图线整卷口径（行测三 subject 合一张卷）——mockline 全真卷只有 exam，或 URL 显式 line=1；服务端无蓝图时回落 subject 池/404 */
  function kpParams() {
    var sp = new URLSearchParams(location.search);
    var exam = sp.get('exam') || ''; var subject = sp.get('subject') || '';
    var line = sp.get('line') === '1' || sp.get('mode') === 'mockline';
    if (!/^[\w-]{1,40}$/.test(exam)) return null;
    if (!/^[\w-]{1,40}$/.test(subject)) { if (!line) return null; subject = ''; }
    return { exam: exam, subject: subject, line: line };
  }
  function kpmapUrl(p) {
    return '/api/kpmap?exam=' + encodeURIComponent(p.exam) + (p.subject ? '&subject=' + encodeURIComponent(p.subject) : '') + (p.line ? '&line=1' : '');
  }
  function prefetchKpmap() {
    if (kpmapP) return kpmapP;
    var p = kpParams();
    if (!p) { kpmapP = Promise.resolve(null); return kpmapP; }
    kpmapP = fetch(kpmapUrl(p))
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (d) { kpmapData = d; return d; })
      .catch(function () { return null; });
    return kpmapP;
  }
  /* 最多等 1.5s；超时/失败照常渲染（累计行退回异步补位，fail-open） */
  function kpmapReady(cb) {
    var fired = false;
    function fire() { if (!fired) { fired = true; cb(); } }
    prefetchKpmap().then(fire, fire);
    setTimeout(fire, 1500);
  }

  var sessPayload = null; /* 随机卷整卷负载：每次写会话都带上，否则作答后刷新会换卷 */
  function saveSession(payload) {
    try {
      if (payload) sessPayload = payload;
      var s = { i: ws.i, ans: ws.ans, mk: ws.mk, ex: ws.ex, start: ws.start, end: ws.end, submitted: ws.submitted, hist: ws.hist ? 1 : 0, used: ws.used || 0, po: ws.po || 0, pa: ws.pa || 0, qt: ws.qt, ps: ws.ps ? 1 : 0, psr: ws.psr || null, cb: ws.cb || 0, cbm: ws.cbm || 0, ap: autoPaused ? 1 : 0, air: ws.air || '', pavg: ws.pavg || 0, pavgn: ws.pavgn || 0, to: ws.to ? 1 : 0, rf: ws.rf || '', qsd: Array.isArray(ws.qsd) ? ws.qsd : null };
      if (sessPayload) s.payload = sessPayload;
      sessionStorage.setItem(SKEY, JSON.stringify(s));
    } catch (_) { /* noop */ }
    writeLast();
  }
  /* 首页「继续上次练习」直回操作台：tiku-last 存完整路径+查询串与进度 */
  function writeLast() {
    if (ws.submitted || !meta) return;
    var a = 0;
    ws.ans.forEach(function (x) { if (x.done || (x.picked && x.picked.length > 0)) a++; });
    store.write('tiku-last', { u: location.pathname + location.search + HXS, s: meta.title, a: a, n: qs.length });
  }
  function readSession() {
    try { return JSON.parse(sessionStorage.getItem(SKEY) || 'null'); } catch (_) { return null; }
  }

  /* QA/自动化流量标记：Playwright/Lighthouse（navigator.webdriver）或 ?qa=1 写入的 tiku-qa=1 → 上报体带 qa:true，服务端不落库（docs/plan-r497） */
  function qaOn() {
    try { return navigator.webdriver === true || localStorage.getItem('tiku-qa') === '1'; } catch (_) { return navigator.webdriver === true; }
  }
  function postHeaders() {
    var h = { 'Content-Type': 'application/json' };
    if (qaOn()) h['x-qa-audit'] = '1';
    return h;
  }
  /* 非 2xx 写接口响应 → 以服务端 {error} 文案（如 429「操作太频繁」）拒绝；无 JSON 用 fallback。err.shown 标记可直出（网络异常的英文 message 不直出；app.js 同形） */
  function rejectWith(r, fallback) {
    return r.json().catch(function () { return null; }).then(function (j) {
      var e = new Error((j && typeof j.error === 'string' && j.error) || fallback); e.shown = true; throw e;
    });
  }
  function shownMsg(e, fallback) { return e && e.shown && e.message ? e.message : fallback; }
  /* 全站答题计数上报（匿名聚合，失败静默）；展示见 statLine()。
   * 交卷统一判分时 attemptBatch 为数组：逐题只入队，flushAttempts() 整卷一次 POST /api/attempts（130 题连发单条会撞 60/分频控） */
  var attemptBatch = null;
  function reportAttempt(slug, ok, picked, ms) {
    if (attemptBatch) { attemptBatch.push({ slug: slug, ok: ok, picked: picked || [], ms: ms > 0 ? ms : undefined }); return; }
    try {
      var body = JSON.stringify({ slug: slug, ok: ok, picked: picked || [], ms: ms > 0 ? ms : undefined, qa: qaOn() || undefined });
      if (navigator.sendBeacon && navigator.sendBeacon('/api/attempt', new Blob([body], { type: 'application/json' }))) return;
      fetch('/api/attempt', { method: 'POST', headers: postHeaders(), body: body, keepalive: true }).catch(function () { /* noop */ });
    } catch (_) { /* noop */ }
  }
  function flushAttempts() {
    var items = attemptBatch || [];
    attemptBatch = null;
    if (items.length === 0) return;
    if (items.length === 1) { reportAttempt(items[0].slug, items[0].ok, items[0].picked, items[0].ms || 0); return; }
    try {
      var body = JSON.stringify({ items: items, qa: qaOn() || undefined });
      if (navigator.sendBeacon && navigator.sendBeacon('/api/attempts', new Blob([body], { type: 'application/json' }))) return;
      fetch('/api/attempts', { method: 'POST', headers: postHeaders(), body: body, keepalive: true }).catch(function () { /* noop */ });
    } catch (_) { /* noop */ }
  }
  function statLine(slug) {
    var line = el('p', 'js-qstat hidden text-[13px] text-muted');
    fetch('/api/qstats?slugs=' + encodeURIComponent(slug))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var it = (d.items || [])[0];
        if (!it || it.attempts < 5) return;
        var pct = Math.round(it.correct / it.attempts * 100);
        line.textContent = '全站正确率 ' + pct + '% · ' + it.attempts + ' 人做过' + (it.mis ? ' · 易错项 ' + it.mis : '') + (it.avgms ? ' · 平均用时 ' + Math.round(it.avgms / 1000) + ' 秒' : '');
        if (pct < 50) {
          var badge = el('span', 'ml-2 rounded bg-red-100 px-1.5 py-0.5 text-[12px] font-medium text-red-700', '易错');
          line.appendChild(badge);
        }
        line.classList.remove('hidden');
      }).catch(function () { /* noop */ });
    return line;
  }

  /* 每日一练连续打卡天数（与 app.js initStreak 同算法：今天无记录则从昨天起算） */
  function dailyStreak() {
    var days = store.read('tiku-days', '{}');
    var n = 0; var d = new Date();
    if (!days[localDay(d)]) { d.setDate(d.getDate() - 1); }
    while (days[localDay(d)]) { n++; d.setDate(d.getDate() - 1); }
    return n;
  }

  /* ---------- 记分（与 /q/ 页同一 localStorage 契约） ---------- */
  /* 考点页「我的进度」卡首帧依据 tiku-kpcard[exam/subject/kp]（与 app.js writeKpCard/touchKpCard 同契约：LRU 50；
     作答处写 [1, wrong] 二元，薄弱沿用旧值；报告 applyKpHistory 按 kpmap 全考点口径写回三元 [1, wrong, weak]） */
  var KPCARD_MAX = 50;
  var KP_HREF_RE = /^\/kaoshi\/([\w-]+)\/([\w-]+)\/kp\/([\w-]+)\/$/;
  function putKpCard(all, key, val) {
    delete all[key];
    var keys = Object.keys(all);
    while (keys.length >= KPCARD_MAX) delete all[keys.shift()];
    all[key] = val;
  }
  function readKpCards() {
    var all = store.read('tiku-kpcard', '{}');
    return all && typeof all === 'object' && !Array.isArray(all) ? all : {};
  }
  function writeKpCard(href, val) {
    var m = KP_HREF_RE.exec(href || '');
    if (!m) return;
    var all = readKpCards();
    putKpCard(all, m[1] + '/' + m[2] + '/' + m[3], val);
    store.write('tiku-kpcard', all);
  }
  function touchKpCard(hrefs, ok) {
    var all = readKpCards();
    hrefs.forEach(function (h) {
      var m = KP_HREF_RE.exec(h || '');
      if (!m) return;
      var key = m[1] + '/' + m[2] + '/' + m[3];
      var old = all[key];
      var wrong = (Array.isArray(old) && old[1]) || !ok ? 1 : 0;
      putKpCard(all, key, Array.isArray(old) && old.length > 2 ? [1, wrong, old[2]] : [1, wrong]);
    });
    store.write('tiku-kpcard', all);
  }

  /* 上次作答 tiku-pick {slug: 'B'|'AC'}（与 app.js 同口径）：只记计分作答，返回旧值（首答 ''），上限 1000 条删最早插入 */
  function rememberPick(slug, pick) {
    if (!slug || !pick) return '';
    var all = store.read('tiku-pick', '{}');
    if (!all || typeof all !== 'object' || Array.isArray(all)) all = {};
    var prev = /^[A-H]{1,8}$/.test(all[slug]) ? all[slug] : '';
    delete all[slug]; all[slug] = pick;
    var keys = Object.keys(all);
    while (keys.length > 1000) { delete all[keys.shift()]; }
    store.write('tiku-pick', all);
    return prev;
  }
  function prevPickNote(prev, pick, ok) {
    if (!prev) return '';
    return prev === pick ? (ok ? '' : ' · 上次也选 ' + prev) : ' · 上次选 ' + prev;
  }

  /* 返回本题上次计分作答（无/不计分 ''） */
  function recordAnswer(q, ok, counted, picked, ms) {
    var p = '/q/' + q.slug + '/';
    var done = store.readList('tiku-done');
    if (done.indexOf(p) < 0) { done.push(p); store.write('tiku-done', done); }
    touchKpCard((q.kps || []).map(function (k) { return k.href; }), ok || !counted);
    if (!counted) return '';
    reportAttempt(q.slug, ok, picked, ms);
    var prevPick = rememberPick(q.slug, picked.slice().sort().join(''));
    var st = store.read('tiku-stats', '{"a":0,"c":0}');
    st.a++; if (ok) st.c++;
    store.write('tiku-stats', st);
    var days = store.read('tiku-days', '{}');
    var dk = localDay(new Date());
    days[dk] = (days[dk] || 0) + 1;
    var dkeys = Object.keys(days).sort();
    while (dkeys.length > 126) { delete days[dkeys.shift()]; }
    store.write('tiku-days', days);
    var dok = store.read('tiku-dayok', '{}');
    dok[dk] = (dok[dk] || 0) + (ok ? 1 : 0);
    var okeys = Object.keys(dok).sort();
    while (okeys.length > 126) { delete dok[okeys.shift()]; }
    store.write('tiku-dayok', dok);
    var wrong = store.readList('tiku-wrong');
    var wi = wrong.indexOf(p);
    var wt = store.read('tiku-wrongt', '{}');
    var wkr = store.read('tiku-wrongk', '{}');
    if (!ok) {
      if (wi < 0) wrong.push(p);
      wt[p] = Math.floor(Date.now() / 1000);
      delete wkr[p];
      var glw = store.readList('tiku-wronggl');
      var gliw = glw.indexOf(p);
      if (gliw >= 0) { glw.splice(gliw, 1); store.write('tiku-wronggl', glw); }
    } else if (wi >= 0 && reviewDue(wt[p], wkr[p])) {
      /* 间隔复习：到期后答对才推进轮次（1/3/7 天），未到期答对不改时间戳与轮次；第三轮答对出师移出并归档 */
      var stg = wkr[p] || 0;
      if (stg >= 2) {
        wrong.splice(wi, 1); delete wt[p]; delete wkr[p];
        store.write('tiku-wrongg', (store.read('tiku-wrongg', '0') || 0) + 1);
        var glg = store.readList('tiku-wronggl');
        if (glg.indexOf(p) < 0) {
          glg.push(p);
          if (glg.length > 200) glg.splice(0, glg.length - 200);
          store.write('tiku-wronggl', glg);
        }
      }
      else { wkr[p] = stg + 1; wt[p] = Math.floor(Date.now() / 1000); }
    }
    store.write('tiku-wrong', wrong);
    store.write('tiku-wrongt', wt);
    store.write('tiku-wrongk', wkr);
    /* 错题次数：答错 +1，答对不清零（历史保留），超 500 条删计数最小者 */
    if (!ok) {
      var wn = store.read('tiku-wrongn', '{}');
      wn[q.slug] = (wn[q.slug] || 0) + 1;
      var wk = Object.keys(wn);
      while (wk.length > 500) {
        var minK = wk[0];
        wk.forEach(function (k) { if (wn[k] < wn[minK]) minK = k; });
        delete wn[minK]; wk = Object.keys(wn);
      }
      store.write('tiku-wrongn', wn);
    }
    return prevPick;
  }

  /* ---------- 题卡渲染 ---------- */
  function markBtn(btn, state) {
    var badge = btn.querySelector('.js-badge'); var mark = btn.querySelector('.js-mark');
    btn.classList.remove('hover:border-brand-600/50', 'hover:bg-brand-50/40');
    btn.disabled = true;
    if (state === 'correct') {
      btn.classList.remove('border-line', 'bg-white'); btn.classList.add('border-emerald-500', 'bg-emerald-50');
      badge.classList.remove('border', 'border-line', 'text-muted'); badge.classList.add('bg-emerald-700', 'text-white');
      mark.className = 'js-mark mt-0.5 flex items-center gap-1 text-sm font-medium text-emerald-700';
      mark.innerHTML = CHECK + '正确答案';
    } else if (state === 'wrong') {
      btn.classList.remove('border-line', 'bg-white'); btn.classList.add('border-red-400', 'bg-red-50');
      badge.classList.remove('border', 'border-line', 'text-muted'); badge.classList.add('bg-red-600', 'text-white');
      mark.className = 'js-mark mt-0.5 flex items-center gap-1 text-sm font-medium text-red-700';
      mark.innerHTML = CROSS + '你的选择';
    } else {
      btn.classList.add('opacity-60', 'pointer-events-none');
    }
  }

  /* 选项排除（docs/plan-r594）：ws.ex[i] 为本题已排除字母串（排序），只在未判分时生效、判分即清空；不进 localStorage、不上报 */
  function exclToggle(s, k) {
    s = typeof s === 'string' ? s : '';
    return s.indexOf(k) >= 0 ? s.replace(k, '') : (s + k).split('').sort().join('');
  }
  function paintExcl(btn, on) {
    btn.dataset.excl = on ? '1' : '';
    btn.classList.toggle('qz-excl', on);
    var sr = btn.querySelector('.js-excl-sr');
    if (on && !sr) btn.appendChild(el('span', 'js-excl-sr sr-only', '（已排除）'));
    if (!on && sr) sr.remove();
  }
  /* 键盘 Shift+字母 入口：renderQ 在可作答态挂上当前题的切换函数，其余态为 null */
  var curExcl = null;

  /* 题目笔记（tiku-note 契约与 app.js 一致：{slug:{t:文本,u:更新秒}}） */
  var NOTE_KEY = 'tiku-note';
  function noteBox(slug) {
    var box = el('div', 'rounded-2xl border border-line bg-white p-4 shadow-sm');
    box.appendChild(el('p', 'text-sm font-semibold', '我的笔记'));
    var ta = document.createElement('textarea');
    ta.rows = 3; ta.maxLength = 1000; ta.name = 'note-' + slug; ta.setAttribute('aria-label', '我的笔记');
    ta.placeholder = '记录你的解题思路、易混点…';
    ta.className = 'mt-2 w-full resize-y rounded-xl border border-line bg-slate-50 p-3 text-[15px] leading-relaxed focus:outline-hidden focus:ring-2 focus:ring-brand-600/40';
    var msg = el('p', 'mt-1.5 text-[12px] text-muted', '仅保存在本浏览器 · 输入后自动保存');
    function readNotes() {
      var n = store.read(NOTE_KEY, '{}');
      return (n && typeof n === 'object' && !Array.isArray(n)) ? n : {};
    }
    var cur = readNotes()[slug];
    if (cur && cur.t) { ta.value = cur.t; }
    var timer = null; var dirty = false;
    function flush() {
      if (!dirty) return;
      dirty = false; if (timer) { clearTimeout(timer); timer = null; }
      var notes = readNotes();
      var t = String(ta.value || '').slice(0, 1000).replace(/\s+$/, '');
      if (t) { notes[slug] = { t: t, u: Math.floor(Date.now() / 1000) }; } else { delete notes[slug]; }
      store.write(NOTE_KEY, notes);
      msg.textContent = t ? '已保存 · 仅保存在本浏览器' : '已删除这条笔记';
    }
    ta.addEventListener('input', function () {
      dirty = true;
      msg.textContent = '输入中…';
      if (timer) { clearTimeout(timer); }
      timer = setTimeout(flush, 600);
    });
    ta.addEventListener('blur', flush);
    box.appendChild(ta); box.appendChild(msg);
    return box;
  }

  /* 题目纠错（匿名 POST /api/feedback；同题同会话仅一次，sessionStorage tiku-fb:<slug>） */
  var FB_KINDS = [['answer', '答案有误'], ['stem', '题干或选项有误'], ['explain', '解析有误'], ['other', '其他']];
  function feedbackBox(slug) {
    var det = document.createElement('details');
    det.className = 'rounded-2xl border border-line bg-white p-4 shadow-sm';
    var sum = document.createElement('summary');
    sum.className = 'tap-y cursor-pointer py-1 text-sm font-semibold text-muted hover:text-ink';
    sum.textContent = '纠错：这道题有问题？';
    det.appendChild(sum);
    var msg = el('p', 'mt-3 text-sm text-emerald-700', '已收到，感谢纠错！我们会尽快核查。');
    msg.hidden = true;
    var form = document.createElement('form');
    form.className = 'mt-3 space-y-3';
    var row = el('div', 'flex flex-wrap gap-2 text-[13px]');
    row.setAttribute('role', 'radiogroup'); row.setAttribute('aria-label', '问题类型');
    FB_KINDS.forEach(function (k, i) {
      var lab = el('label', 'inline-flex h-10 md:h-9 cursor-pointer items-center gap-1.5 rounded-lg border border-line bg-slate-50 px-3 has-[:checked]:border-brand-600 has-[:checked]:bg-brand-50 has-[:checked]:text-brand-800');
      var r = document.createElement('input');
      r.type = 'radio'; r.name = 'fb-kind'; r.value = k[0]; r.className = 'size-3.5 accent-brand-700';
      if (i === 0) r.checked = true;
      lab.appendChild(r); lab.appendChild(document.createTextNode(k[1])); row.appendChild(lab);
    });
    var ta = document.createElement('textarea');
    ta.rows = 2; ta.maxLength = 500; ta.name = 'fb-detail';
    ta.placeholder = '补充说明（选填）…';
    ta.className = 'w-full resize-y rounded-xl border border-line bg-slate-50 p-3 text-[15px] leading-relaxed focus:outline-hidden focus:ring-2 focus:ring-brand-600/40';
    var btn = el('button', 'inline-flex h-11 items-center justify-center rounded-xl border border-brand-700 bg-white px-5 text-sm font-medium text-brand-700 hover:bg-brand-50', '提交纠错');
    btn.type = 'submit';
    form.appendChild(row); form.appendChild(ta); form.appendChild(btn);
    var done = false;
    try { done = sessionStorage.getItem('tiku-fb:' + slug) === '1'; } catch (_) { /* noop */ }
    function thanks() { form.hidden = true; msg.hidden = false; }
    if (done) thanks();
    var busy = false;
    var errLine = el('p', 'text-sm text-red-600', '提交失败，请稍后重试');
    errLine.setAttribute('role', 'status');
    errLine.hidden = true;
    form.appendChild(errLine);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (done || busy) return;
      busy = true;
      btn.disabled = true; btn.textContent = '提交中…';
      errLine.hidden = true;
      var checked = form.querySelector('input[name="fb-kind"]:checked');
      fetch('/api/feedback', {
        method: 'POST',
        headers: postHeaders(),
        body: JSON.stringify({ slug: slug, kind: checked ? checked.value : 'other', detail: String(ta.value || '').slice(0, 500), qa: qaOn() || undefined })
      }).then(function (r) {
        if (!r.ok) return rejectWith(r, '提交失败，请稍后重试');
        done = true;
        try { sessionStorage.setItem('tiku-fb:' + slug, '1'); } catch (_) { /* noop */ }
        /* 纠错记录 tiku-fbk：{s,k,d,ts} 新在前 cap 30，/my/「我的纠错」回访 */
        try {
          var fl = JSON.parse(localStorage.getItem('tiku-fbk') || '[]');
          if (!Array.isArray(fl)) fl = [];
          fl.unshift({ s: slug, k: checked ? checked.value : 'other', d: String(ta.value || '').slice(0, 60), ts: Date.now() });
          localStorage.setItem('tiku-fbk', JSON.stringify(fl.slice(0, 30)));
        } catch (_) { /* noop */ }
        thanks();
      }).catch(function (e) {
        errLine.textContent = shownMsg(e, '提交失败，请稍后重试');
        errLine.hidden = false;
      }).finally(function () {
        busy = false;
        btn.disabled = false; btn.textContent = '提交纠错';
      });
    });
    det.appendChild(form); det.appendChild(msg);
    return det;
  }

  /* AI 答疑（POST /api/ai-ask；同题同问服务端缓存，匿名令牌 tiku-aitok 每日限次） */
  var AI_PRESETS = ['为什么选这个答案？', '其他选项错在哪里？', '换个通俗说法再讲一遍'];
  function aiToken() {
    var t = '';
    try { t = localStorage.getItem('tiku-aitok') || ''; } catch (_) { /* noop */ }
    if (!/^[\w-]{8,64}$/.test(t)) {
      t = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('t' + Date.now() + Math.random().toString(36).slice(2, 10));
      try { localStorage.setItem('tiku-aitok', t); } catch (_) { /* noop */ }
    }
    return t;
  }
  function aiAskBox(slug) {
    var det = document.createElement('details');
    det.className = 'js-ai-ask rounded-2xl border border-brand-200 bg-brand-50/40 p-4 shadow-sm';
    var sum = document.createElement('summary');
    sum.className = 'tap-y cursor-pointer py-1 text-sm font-semibold text-brand-800 hover:text-brand-900';
    sum.textContent = 'AI 答疑：对解析还有疑问？';
    det.appendChild(sum);
    var thread = el('div', 'mt-3 space-y-3');
    det.appendChild(thread);
    /* 回显本题历史答疑（tiku-ai，最多 5 条，与 /q/ 页 app.js 同口径） */
    var past = store.readList('tiku-ai').filter(function (v) {
      return v && v.s === slug && typeof v.q === 'string' && typeof v.a === 'string' && typeof v.ts === 'number';
    }).slice(0, 5).reverse();
    if (past.length > 0) {
      thread.appendChild(el('p', 'text-[12px] text-muted', '历史答疑 · ' + past.length + ' 条'));
      past.forEach(function (v) {
        var qEl = el('div', 'rounded-xl bg-white p-3 text-[14px] leading-relaxed');
        qEl.appendChild(el('p', 'font-medium text-brand-800', '问：' + v.q));
        var aEl = el('div', 'mt-2 space-y-2 border-t border-line pt-2 text-[14px] leading-relaxed text-slate-700');
        String(v.a).split(/\n+/).forEach(function (p) {
          p = p.trim();
          if (p) aEl.appendChild(el('p', '', p));
        });
        qEl.appendChild(aEl);
        thread.appendChild(qEl);
      });
      sum.textContent = 'AI 答疑：对解析还有疑问？（' + past.length + ' 条历史）';
    }
    var row = el('div', 'mt-3 flex flex-wrap gap-2');
    var input = document.createElement('input');
    input.type = 'text'; input.maxLength = 200; input.name = 'ai-question';
    input.placeholder = '也可以自己输入问题…（2–200 字）';
    input.setAttribute('aria-label', '向 AI 提问');
    input.className = 'h-10 min-w-0 flex-1 rounded-lg border border-line bg-white px-3 text-sm focus:outline-hidden focus:ring-2 focus:ring-brand-600/40';
    var btn = el('button', 'inline-flex h-10 shrink-0 items-center justify-center rounded-lg bg-brand-700 px-4 text-sm font-medium text-white hover:bg-brand-800 disabled:opacity-60', '提问');
    btn.type = 'button';
    var msg = el('p', 'mt-2 text-[13px] text-muted', '');
    msg.hidden = true;
    var busy = false;
    function ask(q) {
      q = String(q || '').trim();
      if (busy || q.length < 2) return;
      busy = true; btn.disabled = true;
      msg.hidden = false; msg.className = 'mt-2 text-[13px] text-muted'; msg.textContent = 'AI 思考中…';
      var qEl = el('div', 'rounded-xl bg-white p-3 text-[14px] leading-relaxed');
      qEl.appendChild(el('p', 'font-medium text-brand-800', '问：' + q));
      thread.appendChild(qEl);
      fetch('/api/ai-ask', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ slug: slug, q: q, token: aiToken() })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); }).then(function (res) {
        if (!res.ok) throw new Error(res.d && res.d.error ? res.d.error : '请求失败');
        var aEl = el('div', 'mt-2 space-y-2 border-t border-line pt-2 text-[14px] leading-relaxed text-slate-700');
        String(res.d.answer || '').split(/\n+/).forEach(function (p) {
          p = p.trim();
          if (p) aEl.appendChild(el('p', '', p));
        });
        qEl.appendChild(aEl);
        msg.textContent = typeof res.d.left === 'number' ? '今日剩余 ' + res.d.left + ' 次 · AI 回答仅供参考' : 'AI 回答仅供参考';
        input.value = '';
        /* 答疑历史 tiku-ai：{s,q,a,ts} s+q 去重置顶 cap 30，与 /q/ 页（app.js）同口径，/my/「我的 AI 答疑」回访 */
        var log = store.readList('tiku-ai').filter(function (v) {
          return v && typeof v.s === 'string' && typeof v.q === 'string' && typeof v.a === 'string' && typeof v.ts === 'number' && !(v.s === slug && v.q === q);
        });
        log.unshift({ s: slug, q: q.slice(0, 200), a: String(res.d.answer || '').slice(0, 500), ts: Math.floor(Date.now() / 1000) });
        store.write('tiku-ai', log.slice(0, 30));
      }).catch(function (e) {
        qEl.remove();
        msg.className = 'mt-2 text-[13px] text-red-600';
        msg.textContent = (e && e.message) ? e.message : 'AI 答疑暂不可用，请稍后重试';
      }).finally(function () {
        busy = false; btn.disabled = false;
      });
    }
    var chips = el('div', 'mt-3 flex flex-wrap gap-2');
    AI_PRESETS.forEach(function (p) {
      var c = el('button', 'inline-flex h-10 md:h-9 items-center rounded-lg border border-brand-200 bg-white px-3 text-[13px] text-brand-800 hover:bg-brand-50', p);
      c.type = 'button';
      c.addEventListener('click', function () { ask(p); });
      chips.appendChild(c);
    });
    det.appendChild(chips);
    row.appendChild(input); row.appendChild(btn);
    det.appendChild(row);
    det.appendChild(msg);
    btn.addEventListener('click', function () { ask(input.value); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); ask(input.value); } });
    return det;
  }

  /* 题目讨论区（匿名评论，复用 /api/comment(s)；折叠卡，首次展开才加载） */
  function discussBox(slug) {
    var det = document.createElement('details');
    det.className = 'rounded-2xl border border-line bg-white p-4 shadow-sm';
    var sum = document.createElement('summary');
    sum.className = 'tap-y cursor-pointer py-1 text-sm font-semibold text-muted hover:text-ink';
    sum.textContent = '讨论区：看看大家的思路（匿名）';
    det.appendChild(sum);
    var list = el('ul', 'mt-3 space-y-3');
    var empty = el('p', 'mt-3 text-sm text-muted', '还没有讨论，来发第一条思路吧。');
    empty.hidden = true;
    /* 评论动作（有用/删除/举报）失败提示：挂在该条评论按钮行之后的红字（空串移除；app.js rowNote 同形） */
    function rowNote(li, text) {
      var p = li.querySelector(':scope > .js-disc-err');
      if (!text) { if (p) p.remove(); return; }
      if (!p) {
        p = el('p', 'js-disc-err mt-1 text-[12px] text-red-600', ''); p.setAttribute('role', 'status');
        var sub = li.querySelector(':scope > ul'); if (sub) li.insertBefore(p, sub); else li.appendChild(p);
      }
      p.textContent = text;
    }
    function actFail(r) { return r.ok ? r.json() : rejectWith(r, '操作失败，请稍后重试'); }
    /* 「有用」点赞：tiku-clike 记录已点评论 id，防重复 */
    function likeBtn(it, li) {
      var btn = document.createElement('button');
      btn.type = 'button';
      var n = it.likes || 0;
      var liked = !it.id || store.readList('tiku-clike').indexOf(it.id) >= 0;
      function paint() {
        btn.textContent = '有用' + (n > 0 ? ' ' + n : '');
        btn.disabled = liked;
        btn.className = liked
          ? 'mt-2 tap-y inline-flex h-7 items-center rounded-full bg-brand-50 px-2.5 text-[12px] font-medium text-brand-700'
          : 'mt-2 tap-y inline-flex h-7 items-center rounded-full border border-line bg-white px-2.5 text-[12px] text-muted hover:text-ink';
      }
      paint();
      btn.addEventListener('click', function () {
        if (liked || !it.id) return;
        liked = true; paint();
        fetch('/api/comment/like', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ slug: slug, id: it.id })
        }).then(actFail).then(function (j) {
          if (!j || !j.ok) { var e = new Error('操作失败，请稍后重试'); e.shown = true; throw e; }
          n = j.likes; var ids = store.readList('tiku-clike'); ids.push(it.id); store.write('tiku-clike', ids); paint(); rowNote(li, '');
        }).catch(function (e) { liked = false; paint(); rowNote(li, shownMsg(e, '操作失败，请稍后重试')); });
      });
      return btn;
    }
    /* 删除自己的评论：tiku-ctok 保存发表时领取的令牌 {id: token}，保留最近 200 条 */
    function readTok() { try { var o = JSON.parse(localStorage.getItem('tiku-ctok') || '{}'); return o && typeof o === 'object' ? o : {}; } catch (_) { return {}; } }
    function saveTok(id, token) {
      try {
        var o = readTok(); o[id] = token;
        var ks = Object.keys(o); if (ks.length > 200) { ks.sort(function (a, b) { return a - b; }).slice(0, ks.length - 200).forEach(function (k) { delete o[k]; }); }
        localStorage.setItem('tiku-ctok', JSON.stringify(o));
      } catch (_) { /* noop */ }
    }
    /* 删除成功后清本机残留：本条及其下回复（li[data-id]）的 tiku-ctok 令牌与 tiku-clike 已赞 id（app.js forgetTok 同形） */
    function forgetTok(li) {
      var ids = [li.getAttribute('data-id')].concat(Array.prototype.map.call(li.querySelectorAll('li[data-id]'), function (n) { return n.getAttribute('data-id'); })).filter(Boolean);
      try {
        var o = readTok(); ids.forEach(function (id) { delete o[id]; });
        localStorage.setItem('tiku-ctok', JSON.stringify(o));
      } catch (_) { /* noop */ }
      var likes = store.readList('tiku-clike').filter(function (id) { return ids.indexOf(String(id)) < 0; });
      store.write('tiku-clike', likes);
    }
    function delBtn(it, li) {
      var tok = readTok()[it.id];
      if (!tok) return null;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ml-2 mt-2 tap-y inline-flex h-7 items-center rounded-full border border-line bg-white px-2.5 text-[12px] text-muted hover:text-red-600';
      btn.textContent = '删除';
      btn.addEventListener('click', function () {
        if (!window.confirm('删除这条评论？' + ((it.pid || 0) > 0 ? '' : '其下回复会一并删除。'))) return;
        btn.disabled = true;
        fetch('/api/comment/delete', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ slug: slug, id: it.id, token: tok })
        }).then(actFail).then(function (j) {
          if (!j || !j.ok) { var e = new Error('操作失败，请稍后重试'); e.shown = true; throw e; }
          if (!((it.pid || 0) > 0)) { delete subLists[it.id]; total = Math.max(0, total - 1); paintCount(); }
          forgetTok(li);
          li.remove();
          empty.hidden = list.children.length > 0;
        }).catch(function (e) { btn.disabled = false; rowNote(li, shownMsg(e, '操作失败，请稍后重试')); });
      });
      return btn;
    }
    /* 举报：tiku-rtok 匿名令牌（首次生成），tiku-crep 记录已举报 id，多人举报自动隐藏 */
    function rtok() {
      try {
        var t = localStorage.getItem('tiku-rtok');
        if (!t) {
          t = '';
          var a = new Uint8Array(16); crypto.getRandomValues(a);
          for (var i = 0; i < a.length; i++) { t += ('0' + a[i].toString(16)).slice(-2); }
          localStorage.setItem('tiku-rtok', t);
        }
        return t;
      } catch (_) { return ''; }
    }
    function reportBtn(it, li) {
      if (!it.id || readTok()[it.id]) return null;
      var btn = document.createElement('button');
      btn.type = 'button';
      var done = store.readList('tiku-crep').indexOf(it.id) >= 0;
      function paint() {
        btn.textContent = done ? '已举报' : '举报';
        btn.disabled = done;
        btn.className = done
          ? 'ml-2 mt-2 tap-y inline-flex h-7 items-center rounded-full bg-slate-100 px-2.5 text-[12px] text-muted'
          : 'ml-2 mt-2 tap-y inline-flex h-7 items-center rounded-full border border-line bg-white px-2.5 text-[12px] text-muted hover:text-red-600';
      }
      paint();
      btn.addEventListener('click', function () {
        if (done) return;
        if (!window.confirm('举报这条评论（辱骂/广告/严重误导）？多人举报后将被隐藏。')) return;
        var t = rtok(); if (!t) return;
        btn.disabled = true;
        fetch('/api/comment/report', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ slug: slug, id: it.id, token: t })
        }).then(actFail).then(function (j) {
          if (!j || !j.ok) { var e = new Error('操作失败，请稍后重试'); e.shown = true; throw e; }
          done = true; var ids = store.readList('tiku-crep'); ids.push(it.id); store.write('tiku-crep', ids); paint(); rowNote(li, '');
          if (j.hidden) {
            if (!((it.pid || 0) > 0)) { delete subLists[it.id]; total = Math.max(0, total - 1); paintCount(); }
            li.remove();
            empty.hidden = list.children.length > 0;
          }
        }).catch(function (e) { btn.disabled = false; rowNote(li, shownMsg(e, '操作失败，请稍后重试')); });
      });
      return btn;
    }
    /* 回复模式状态：非空时表单提交带 parent（楼中楼，仅一层） */
    var reply = null;
    var replyBar = el('p', 'text-[13px] text-brand-700', '');
    replyBar.hidden = true;
    var replyCancel = document.createElement('button');
    replyCancel.type = 'button';
    replyCancel.className = 'ml-2 underline';
    replyCancel.textContent = '取消';
    replyCancel.addEventListener('click', function () { reply = null; replyBar.hidden = true; });
    var subLists = {};
    function subList(id) {
      if (!subLists[id]) { subLists[id] = el('ul', 'mt-2 space-y-2 border-l-2 border-line pl-3'); }
      return subLists[id];
    }
    function row(it) {
      var isReply = (it.pid || 0) > 0;
      var li = el('li', isReply ? 'rounded-lg bg-white p-2.5' : 'rounded-xl bg-slate-50 p-3');
      if (it.id) li.setAttribute('data-id', String(it.id));
      var dt = new Date((it.t || 0) * 1000);
      li.appendChild(el('p', 'text-[12px] text-muted', (it.nick || '匿名考友') + ' · ' + (dt.getMonth() + 1) + '月' + dt.getDate() + '日'));
      li.appendChild(el('p', 'mt-1 whitespace-pre-wrap text-[14px] leading-relaxed', it.content || ''));
      li.appendChild(likeBtn(it, li));
      if (!isReply && it.id) {
        var rb = document.createElement('button');
        rb.type = 'button';
        rb.className = 'ml-2 mt-2 tap-y inline-flex h-7 items-center rounded-full border border-line bg-white px-2.5 text-[12px] text-muted hover:text-ink';
        rb.textContent = '回复';
        rb.addEventListener('click', function () {
          reply = { id: it.id, nick: it.nick || '匿名考友' };
          replyBar.textContent = '回复 @' + reply.nick;
          replyBar.appendChild(replyCancel);
          replyBar.hidden = false;
          ta.focus();
        });
        li.appendChild(rb);
      }
      if (it.id) { var db = delBtn(it, li); if (db) li.appendChild(db); }
      if (it.id) { var rp = reportBtn(it, li); if (rp) li.appendChild(rp); }
      if (!isReply && it.id) { li.appendChild(subList(it.id)); }
      return li;
    }
    var total = 0;
    function paintCount() { sum.textContent = '讨论区' + (total > 0 ? '（' + total + '）' : '') + '：看看大家的思路（匿名）'; }
    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'mt-3 inline-flex h-10 md:h-9 items-center rounded-lg border border-line bg-white px-3.5 text-[13px] text-muted hover:text-ink';
    more.textContent = '加载更多讨论';
    more.hidden = true;
    var sort = 'hot';
    var sortWrap = el('div', 'mt-2 flex gap-1.5');
    var sortBtns = {};
    function paintSort() {
      ['hot', 'new'].forEach(function (s) {
        sortBtns[s].className = 'tap-y inline-flex h-7 items-center rounded-full px-2.5 text-[12px] ' +
          (sort === s ? 'bg-brand-700 font-medium text-white' : 'border border-line bg-white text-muted hover:text-ink');
      });
    }
    ['hot', 'new'].forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = s === 'hot' ? '最热' : '最新';
      b.addEventListener('click', function () {
        if (sort === s || moreBusy) return;
        sort = s; paintSort();
        list.textContent = ''; subLists = {}; page = 0;
        loadPage(0).catch(function () { empty.hidden = false; });
      });
      sortBtns[s] = b;
      sortWrap.appendChild(b);
    });
    paintSort();
    var page = 0;
    function loadPage(p) {
      return fetch('/api/comments?slug=' + encodeURIComponent(slug) + '&page=' + p + '&sort=' + sort)
        .then(function (r) { return r.ok ? r.json() : { items: [], total: 0, more: false }; })
        .then(function (j) {
          var items = (j && j.items) || [];
          var tops = items.filter(function (it) { return !(it.pid > 0); });
          var reps = items.filter(function (it) { return it.pid > 0; }).sort(function (a, b) { return (a.t - b.t) || (a.id - b.id); });
          tops.forEach(function (it) { list.appendChild(row(it)); });
          reps.forEach(function (it) { if (subLists[it.pid]) subLists[it.pid].appendChild(row(it)); });
          total = (j && j.total) || 0;
          paintCount();
          empty.hidden = list.children.length > 0;
          more.hidden = !(j && j.more);
        });
    }
    var loaded = false;
    det.addEventListener('toggle', function () {
      if (!det.open || loaded) return;
      loaded = true;
      loadPage(0).catch(function () { empty.hidden = false; });
    });
    var moreBusy = false;
    more.addEventListener('click', function () {
      if (moreBusy) return;
      moreBusy = true; more.disabled = true; more.textContent = '加载中…';
      page += 1;
      loadPage(page).catch(function () { page -= 1; }).finally(function () {
        moreBusy = false; more.disabled = false; more.textContent = '加载更多讨论';
      });
    });
    var form = document.createElement('form');
    form.className = 'mt-4 space-y-2.5';
    var top = el('div', 'flex flex-wrap gap-2.5');
    var nick = document.createElement('input');
    nick.type = 'text'; nick.maxLength = 20; nick.placeholder = '昵称（选填）'; nick.name = 'nick';
    nick.setAttribute('aria-label', '昵称（选填）');
    nick.className = 'h-10 w-36 rounded-lg border border-line bg-slate-50 px-3 text-sm focus:outline-hidden focus:ring-2 focus:ring-brand-600/40';
    try { nick.value = localStorage.getItem('tiku-nick') || ''; } catch (_) { /* noop */ }
    var btn = el('button', 'inline-flex h-10 items-center justify-center rounded-lg bg-brand-700 px-4 text-sm font-medium text-white hover:bg-brand-800', '发表讨论');
    btn.type = 'submit';
    top.appendChild(nick); top.appendChild(btn);
    var ta = document.createElement('textarea');
    ta.rows = 2; ta.maxLength = 300; ta.required = true; ta.name = 'comment'; ta.setAttribute('aria-label', '讨论内容');
    ta.placeholder = '说说你的思路、易混点或助记口诀…（2–300 字，不支持链接）';
    ta.className = 'w-full resize-y rounded-xl border border-line bg-slate-50 p-3 text-[15px] leading-relaxed focus:outline-hidden focus:ring-2 focus:ring-brand-600/40';
    var msg = el('p', 'text-[13px] text-muted', '');
    msg.hidden = true;
    form.appendChild(replyBar); form.appendChild(top); form.appendChild(ta); form.appendChild(msg);
    var busy = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      var content = String(ta.value || '').trim();
      if (content.length < 2) { msg.textContent = '至少写 2 个字'; msg.className = 'text-[13px] text-red-600'; msg.hidden = false; return; }
      busy = true;
      btn.disabled = true; btn.textContent = '发表中…';
      msg.hidden = true;
      try { localStorage.setItem('tiku-nick', String(nick.value || '').trim()); } catch (_) { /* noop */ }
      fetch('/api/comment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ slug: slug, nick: String(nick.value || ''), content: content, parent: reply ? reply.id : 0 })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
        if (!res.ok) throw new Error((res.j && res.j.error) || '发表失败');
        var item = res.j.item;
        if (res.j.token && item.id) { saveTok(item.id, res.j.token); }
        if (item.pid > 0 && subLists[item.pid]) { subLists[item.pid].appendChild(row(item)); }
        else { list.insertBefore(row(item), list.firstChild); total += 1; paintCount(); }
        reply = null; replyBar.hidden = true;
        empty.hidden = true;
        ta.value = '';
        msg.textContent = '已发表'; msg.className = 'text-[13px] text-emerald-700'; msg.hidden = false;
      }).catch(function (err2) {
        msg.textContent = (err2 && err2.message) || '发表失败，请稍后重试'; msg.className = 'text-[13px] text-red-600'; msg.hidden = false;
      }).finally(function () {
        busy = false;
        btn.disabled = false; btn.textContent = '发表讨论';
      });
    });
    det.appendChild(sortWrap); det.appendChild(list); det.appendChild(more); det.appendChild(empty); det.appendChild(form);
    return det;
  }

  function analysisNode(q) {
    var box = el('section', 'js-analysis mt-6 space-y-4');
    var h = el('h2', 'text-lg font-semibold', '深度解析'); box.appendChild(h);
    box.appendChild(statLine(q.slug));
    var ans = el('div', 'rounded-xl border-l-4 border-brand-600 bg-white p-4 shadow-sm');
    ans.appendChild(el('p', 'text-[13px] font-medium uppercase tracking-wide text-brand-700', '正确答案'));
    ans.appendChild(el('p', 'mt-1 text-[15px] font-semibold leading-relaxed', q.answer + (q.qtype === 'multi_choice' ? '（多选）' : '')));
    box.appendChild(ans);
    if (q.steps && q.steps.length > 0) {
      var sd = el('div', 'rounded-2xl border border-line bg-white p-4 shadow-sm md:p-5');
      sd.appendChild(el('p', 'font-semibold', '逐步解析'));
      var ol = el('ol', 'mt-3 space-y-3 text-[15px] leading-relaxed');
      q.steps.forEach(function (s, i) {
        var li = el('li', 'flex gap-2.5');
        li.appendChild(el('span', 'mt-0.5 grid size-5 shrink-0 place-items-center rounded-full bg-slate-100 text-xs font-medium', String(i + 1)));
        li.appendChild(el('span', 'min-w-0 [overflow-wrap:anywhere]', s));
        ol.appendChild(li);
      });
      sd.appendChild(ol); box.appendChild(sd);
    }
    if (q.pitfalls) {
      var pd = el('div', 'rounded-xl border border-red-200 bg-red-50 p-4');
      pd.appendChild(el('p', 'text-sm font-semibold text-red-800', '易错点'));
      pd.appendChild(el('p', 'mt-1 text-[15px] leading-relaxed text-red-900/90 [overflow-wrap:anywhere]', q.pitfalls));
      box.appendChild(pd);
    }
    if ((q.kps && q.kps.length > 0) || q.extension) {
      var kd = el('div', 'rounded-xl border border-brand-200 bg-brand-50 p-4');
      var names = (q.kps || []).map(function (k) { return k.name; }).join('、');
      kd.appendChild(el('p', 'font-semibold text-brand-800', '考点卡' + (names ? ' · ' + names : '')));
      if (q.extension) kd.appendChild(el('p', 'mt-2 text-[14px] leading-relaxed text-brand-800/90 [overflow-wrap:anywhere]', q.extension));
      if (q.kps && q.kps.length > 0) {
        var row = el('div', 'mt-3 flex flex-wrap gap-2');
        q.kps.forEach(function (k) {
          var a = el('a', 'inline-flex h-10 md:h-9 items-center rounded-lg bg-white/70 px-3 text-[13px] text-brand-800 hover:bg-white', k.name);
          a.href = k.href; row.appendChild(a);
        });
        kd.appendChild(row);
      }
      box.appendChild(kd);
    }
    box.appendChild(aiAskBox(q.slug));
    box.appendChild(noteBox(q.slug));
    box.appendChild(feedbackBox(q.slug));
    box.appendChild(discussBox(q.slug));
    return box;
  }

  /* 选项乱序：按题目 slug 派生固定顺序（刷新/回看/重进稳定），判断题与两项以下不乱序，选项字母标识不变 */
  function shufOpts(q) {
    if (!optShuf || q.qtype === 'true_false' || !q.options || q.options.length < 3) return q.options;
    var h = 0; var s = String(q.slug || '');
    for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    var arr = q.options.slice();
    for (var j = arr.length - 1; j > 0; j--) {
      h = (h * 1664525 + 1013904223) >>> 0;
      var k = h % (j + 1);
      var t = arr[j]; arr[j] = arr[k]; arr[k] = t;
    }
    return arr;
  }

  /* 图形推理题图/选项图：服务端 isSafeSvg 同口径的客户端白名单（基础图元 + 无事件/引用/样式属性），不通过则退化为文字描述 */
  var SVG_TAGS = { svg: 1, g: 1, path: 1, rect: 1, circle: 1, ellipse: 1, line: 1, polyline: 1, polygon: 1, text: 1, title: 1 };
  function safeSvg(s) {
    if (typeof s !== 'string' || !s || s.length > 20000) return false;
    var t = s.trim();
    if (t.slice(0, 4) !== '<svg' || t.slice(-6) !== '</svg>') return false;
    if (/<!--|<!\[CDATA\[|<\?|&#|javascript:/i.test(t)) return false;
    var re = /<\s*\/?\s*([a-zA-Z][\w:-]*)([^>]*)>/g; var m;
    while ((m = re.exec(t)) !== null) {
      if (!SVG_TAGS[m[1].toLowerCase()]) return false;
      if (/(^|\s)(on[a-z]+|href|xlink:href|style|src)\s*=/i.test(m[2])) return false;
    }
    return true;
  }
  function figOpts(q) {
    return Boolean(q.options && q.options.length > 0 && q.options.every(function (o) { return safeSvg(o.svg); }));
  }

  /* 材料盒溢出提示 + 展开（R634，与 app.js initQMaterial 同契约）：<lg 单列 max-h-60 / md:50vh 折叠而触屏无常驻滚动条，
     溢出且未滚到底挂 qz-mat-ovf 盒底渐隐，按钮展开 qz-mat-open 撤 max-height，选择 matOpen 在本次作答内沿用；
     ≥lg ws-cols 分栏材料吸顶内滚由 #ws-qcard 规则保持，按钮 lg:hidden（display:none 不占格子） */
  var matOpen = false;
  function matMore(box, card) {
    if (box.scrollHeight <= box.clientHeight + 4) return;
    var btn = el('button', 'qz-mat-more -mt-2 mb-3 inline-flex h-10 items-center rounded-lg px-1.5 text-[13px] font-medium text-amber-800 hover:bg-amber-50 lg:hidden');
    btn.type = 'button';
    function fade() { box.classList.toggle('qz-mat-ovf', !matOpen && box.scrollTop + box.clientHeight < box.scrollHeight - 4); }
    function apply() {
      box.classList.toggle('qz-mat-open', matOpen);
      btn.setAttribute('aria-expanded', matOpen ? 'true' : 'false');
      btn.textContent = matOpen ? '收起材料 ↑' : '展开材料全文 ↓';
      fade();
    }
    btn.addEventListener('click', function () {
      matOpen = !matOpen;
      apply();
      var top = box.getBoundingClientRect().top;
      if (!matOpen && top < 64) window.scrollTo({ top: window.scrollY + top - 64 });
    });
    box.addEventListener('scroll', fade, { passive: true });
    card.appendChild(btn);
    apply();
  }
  /* 材料内宽表横滚可发现性（R672，与 app.js matTblFade 同契约）：可横滚且未滚到右端时包裹层挂 qz-tbl-ovf 右缘渐隐，滚到右端撤；
     每题重建材料盒后重新挂，宽度变化 ResizeObserver 重算（无 RO 退回 resize） */
  function matTblFade(root) {
    Array.prototype.slice.call(root.querySelectorAll('.qz-tbl')).forEach(function (w) {
      var mark = function () { w.classList.toggle('qz-tbl-ovf', w.scrollLeft + w.clientWidth < w.scrollWidth - 2); };
      w.addEventListener('scroll', mark, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(mark).observe(w); else window.addEventListener('resize', mark);
      mark();
    });
  }

  /* focusStem：翻题（按钮/←→）后把焦点落到新题干，键盘与读屏用户有落点，随后 Tab 直达选项 */
  function renderQ(focusStem) {
    if (qtCur !== ws.i) { flushQt(); qtCur = ws.i; qtEnter = Date.now(); }
    var q = qs[ws.i]; var a = ws.ans[ws.i];
    /* 考试模式：交卷后统一判分（背题模式优先，回放态不适用） */
    var deferMode = (defer || timed()) && !browseOn() && !ws.submitted;
    $('ws-qtype').textContent = (QTYPE[q.qtype] || q.qtype) + (q.mat ? ' · 材料题' : '');
    $('ws-diff').textContent = '难度 ' + stars(q.difficulty);
    $('ws-pos').textContent = '第 ' + (ws.i + 1) + ' / ' + qs.length + ' 题' + (q.subject ? ' · ' + q.subject : '');
    $('ws-bar').style.width = Math.round((ws.i + 1) / qs.length * 100) + '%';
    var card = $('ws-qcard');
    /* 同一篇材料的小题之间翻题，材料盒保持上一题的滚动位置（表格常在盒底，不必每题重找） */
    var prevMat = card.querySelector('.qz-material');
    var keepTop = prevMat && q.mat && prevMat.__mat === q.mat ? prevMat.scrollTop : 0;
    card.innerHTML = '';
    if (q.mat) {
      var mbox = el('section', 'qz-material mb-4 max-h-60 overflow-y-auto rounded-xl md:max-h-[50vh] border border-amber-200 border-l-4 border-l-amber-500 bg-amber-50/60 p-4 text-[15px] leading-relaxed');
      mbox.__mat = q.mat;
      mbox.setAttribute('aria-label', '题目材料');
      mbox.setAttribute('tabindex', '0');
      var sibs = qs.filter(function (x) { return x.mat === q.mat; });
      var mLabel = sibs.length > 1 ? '材料 · 本材料第 ' + (sibs.indexOf(q) + 1) + '/' + sibs.length + ' 题' : '材料';
      mbox.appendChild(el('p', 'mb-2 text-[12px] font-semibold uppercase tracking-wide text-amber-700', mLabel));
      matBlocks(q.mat).forEach(function (b) { mbox.appendChild(b); });
      card.appendChild(mbox);
      if (keepTop) mbox.scrollTop = keepTop;
      matTblFade(mbox);
    }
    /* ≥lg 材料题分栏：材料左、题右（styles.css #ws-qcard.ws-cols）；溢出量在分栏类就位后才准 */
    var col = q.mat ? el('div', 'min-w-0') : card;
    card.classList.toggle('ws-cols', Boolean(q.mat));
    if (q.mat) { matMore(mbox, card); card.appendChild(col); }
    var stem = el('h1', 'text-balance text-[17px] font-medium leading-relaxed outline-none md:text-lg', q.stem);
    stem.tabIndex = -1;
    col.appendChild(stem);
    if (safeSvg(q.fig)) {
      var fig = el('figure', 'qz-fig mt-4 rounded-2xl border border-line bg-white p-3 shadow-sm md:p-4');
      fig.innerHTML = q.fig;
      col.appendChild(fig);
    }
    var isMulti = q.qtype === 'multi_choice';
    var optFig = figOpts(q);
    var wrap = el('div', optFig ? 'mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4' : 'mt-5 space-y-3');
    wrap.setAttribute('role', isMulti ? 'group' : 'radiogroup'); wrap.setAttribute('aria-label', '选项');
    wrap.addEventListener('keydown', function (e) {
      var cells = Array.prototype.slice.call(wrap.querySelectorAll('.js-opt:not(:disabled)'));
      var idx = cells.indexOf(document.activeElement);
      if (idx < 0 || cells.length < 2) return;
      var to;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') to = (idx + 1) % cells.length;
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') to = (idx - 1 + cells.length) % cells.length;
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = cells.length - 1;
      else return;
      e.preventDefault(); e.stopPropagation();
      cells[to].focus();
    });
    var verdict = el('div', 'mt-4 hidden items-center justify-between rounded-xl border px-4 py-3');
    verdict.setAttribute('role', 'status'); verdict.setAttribute('aria-live', 'polite');
    var submitBtn = isMulti ? el('button', 'mt-4 hidden h-11 w-full items-center justify-center rounded-xl bg-brand-700 text-sm font-medium text-white hover:bg-brand-800', '提交答案') : null;
    if (submitBtn) submitBtn.type = 'button';
    /* 操作行：flex 整项换行、每项 40px 真实盒（与 /q/ SSR actItem 同结构），折行时触控区不叠到相邻行；外框 mt-1.5 + 40 − mb-2.5 = 原 mt-4 + 20 行高 */
    var revealP = el('p', '-mb-2.5 mt-1.5 flex flex-wrap items-center justify-center text-[13px] text-muted');
    var actItems = [el('span', null, (deferMode ? '交卷后统一判分 · 点击选项记录作答' : isMulti ? '勾选后点「提交答案」判定' : '点击选项立即判定') + '，长按可排除')];
    var hintBtn = null;
    if (q.steps && q.steps.length > 0 && !ws.end) {
      hintBtn = el('button', 'h-10 font-medium text-brand-700 hover:underline', '先看提示');
      hintBtn.type = 'button';
      actItems.push(hintBtn);
    }
    var revealBtn = el('button', 'h-10 font-medium text-brand-700 hover:underline', '先看解析（本题不计分）');
    revealBtn.type = 'button';
    if (!deferMode) actItems.push(revealBtn);
    actItems.forEach(function (ctrl, i) {
      var it = el('span', 'js-act inline-flex h-10 items-center');
      it.appendChild(ctrl);
      if (i < actItems.length - 1) { var sep = el('span', 'mx-1', '·'); sep.setAttribute('aria-hidden', 'true'); it.appendChild(sep); }
      revealP.appendChild(it);
    });
    function hintNode() {
      var box = el('div', 'js-hint mt-4 rounded-xl border border-amber-200 bg-amber-50 p-4');
      box.setAttribute('role', 'note');
      box.appendChild(el('p', 'text-sm font-semibold text-amber-800', '💡 提示（不含答案，本题正常计分）'));
      box.appendChild(el('p', 'mt-1 text-[15px] leading-relaxed text-amber-900/90 [overflow-wrap:anywhere]', q.steps[0]));
      return box;
    }
    var buttons = [];
    shufOpts(q).forEach(function (o) {
      var b = el('button', optFig
        ? 'js-opt qz-optfig flex min-h-[52px] w-full select-none flex-col items-start gap-2 rounded-xl border border-line bg-white p-3 text-left transition hover:border-brand-600/50 hover:bg-brand-50/40 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-brand-600/40'
        : 'js-opt flex min-h-[52px] w-full select-none items-start gap-3 rounded-xl border border-line bg-white px-4 py-3 text-left transition hover:border-brand-600/50 hover:bg-brand-50/40 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-brand-600/40');
      b.type = 'button'; b.dataset.key = o.key;
      b.setAttribute('role', isMulti ? 'checkbox' : 'radio'); b.setAttribute('aria-checked', 'false');
      if (optFig) {
        var head = el('span', 'flex w-full items-center justify-between gap-2');
        head.appendChild(el('span', 'js-badge grid size-6 shrink-0 place-items-center rounded-full border border-line text-[13px] font-medium text-muted', o.key));
        head.appendChild(el('span', 'js-mark hidden items-center gap-1 text-sm font-medium'));
        b.appendChild(head);
        var pic = el('span', 'qz-pic'); pic.innerHTML = o.svg;
        b.appendChild(pic);
        b.appendChild(el('span', 'sr-only', o.text));
      } else {
        b.appendChild(el('span', 'js-badge mt-0.5 grid size-6 shrink-0 place-items-center rounded-full border border-line text-[13px] font-medium text-muted', o.key));
        b.appendChild(el('span', 'flex-1 text-[15px] leading-relaxed md:text-base', o.text));
        b.appendChild(el('span', 'js-mark mt-0.5 hidden items-center gap-1 text-sm font-medium'));
      }
      wrap.appendChild(b); buttons.push(b);
    });
    col.appendChild(wrap);
    if (a.hint && q.steps && q.steps.length > 0) col.appendChild(hintNode());
    if (submitBtn) col.appendChild(submitBtn);
    col.appendChild(verdict);
    col.appendChild(revealP);

    /* 选项排除手势：长按 500 ms（位移 >10 px / 提前松手取消）、鼠标右键、Shift+字母 三入口同一状态；
       长按后紧随的 click 吞掉不作答；触屏长按派生的 contextmenu 只阻默认不再切换（避免双切） */
    var lpFired = false; var lastPtr = 'mouse';
    curExcl = null;
    function wireExcl(b, onExcluded) {
      var k = b.dataset.key; var tm = 0; var sx = 0; var sy = 0;
      function toggle() {
        if (a.done) return;
        ws.ex[ws.i] = exclToggle(ws.ex[ws.i], k);
        var on = ws.ex[ws.i].indexOf(k) >= 0;
        paintExcl(b, on);
        if (on && onExcluded) onExcluded(k);
        saveSession();
      }
      b.__excl = toggle;
      paintExcl(b, (ws.ex[ws.i] || '').indexOf(k) >= 0);
      function cancel() { if (tm) { clearTimeout(tm); tm = 0; } }
      b.addEventListener('pointerdown', function (e) {
        lastPtr = e.pointerType || 'mouse'; lpFired = false;
        if (e.button !== 0) return;
        sx = e.clientX; sy = e.clientY;
        cancel(); tm = setTimeout(function () { tm = 0; lpFired = true; toggle(); }, 500);
      });
      b.addEventListener('pointermove', function (e) { if (tm && (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10)) cancel(); });
      b.addEventListener('pointerup', cancel); b.addEventListener('pointercancel', cancel); b.addEventListener('pointerleave', cancel);
      b.addEventListener('contextmenu', function (e) { e.preventDefault(); if (lastPtr === 'mouse') toggle(); });
    }
    /* click 前置拦截：长按刚触发过 → 吞掉；已排除项 → 取消排除而非作答 */
    function exclClick(b) {
      if (lpFired) { lpFired = false; return true; }
      if (b.dataset.excl === '1') { b.__excl(); return true; }
      return false;
    }
    function armExcl(onExcluded) {
      buttons.forEach(function (b) { wireExcl(b, onExcluded); });
      curExcl = function (key) { var b = buttons.filter(function (x) { return x.dataset.key === key; })[0]; if (b && b.__excl) b.__excl(); };
    }

    function paintDone() {
      curExcl = null;
      buttons.forEach(function (b) {
        var k = b.dataset.key;
        paintExcl(b, false);
        b.setAttribute('aria-checked', a.picked.indexOf(k) >= 0 ? 'true' : 'false');
        if (q.answer.indexOf(k) >= 0) markBtn(b, 'correct');
        else if (a.picked.indexOf(k) >= 0) markBtn(b, 'wrong');
        else markBtn(b, 'dim');
      });
      if (submitBtn) submitBtn.classList.add('hidden');
      revealP.remove();
      if (a.picked.length > 0) {
        verdict.classList.remove('hidden'); verdict.classList.add('flex');
        var rawOk = a.picked.slice().sort().join('') === q.answer.split('').sort().join('');
        var suffix = (a.viewed ? ' · 已看解析，本题不计分' : '') + prevPickNote(a.pp, a.picked.slice().sort().join(''), rawOk);
        if (rawOk) {
          verdict.classList.add('border-emerald-200', 'bg-emerald-50');
          verdict.appendChild(el('p', 'text-sm font-medium text-emerald-800', '回答正确 · 正确答案 ' + q.answer + suffix));
        } else {
          verdict.classList.add('border-red-200', 'bg-red-50');
          var detail = '';
          if (isMulti) {
            var miss = q.answer.split('').filter(function (k) { return a.picked.indexOf(k) < 0; }).join('');
            var extra = a.picked.filter(function (k) { return q.answer.indexOf(k) < 0; }).sort().join('');
            var parts = [];
            if (miss) parts.push('漏选 ' + miss);
            if (extra) parts.push('错选 ' + extra);
            if (parts.length > 0) detail = '（' + parts.join(' · ') + '）';
          }
          verdict.appendChild(el('p', 'text-sm font-medium text-red-800', '回答错误' + detail + ' · 正确答案 ' + q.answer + suffix));
        }
      }
      var oldA = card.querySelector('.js-analysis'); if (oldA) oldA.remove();
      var anode = analysisNode(q);
      /* 答错就地巩固：同考点抽 3 题（排除本题），无考点不显示 */
      if (a.picked.length > 0 && a.picked.slice().sort().join('') !== q.answer.split('').sort().join('') && q.kps && q.kps.length > 0) {
        var km = /^\/kaoshi\/([\w-]+)\/([\w-]+)\/kp\/([\w-]+)\/$/.exec(q.kps[0].href || '');
        if (km) {
          var simP = el('p', 'mt-4');
          var simA = el('a', 'inline-flex h-10 items-center rounded-lg bg-brand-700 px-3.5 text-sm font-medium text-white hover:bg-brand-800', '练 3 道相似题（同考点）→');
          simA.href = '/practice/?mode=custom&exam=' + km[1] + '&subject=' + km[2] + '&kp=' + km[3] + '&n=3#x=' + encodeURIComponent(q.slug);
          simP.appendChild(simA); anode.appendChild(simP);
        }
      }
      col.appendChild(anode);
    }

    function finish(picked) {
      var ok = picked.slice().sort().join('') === q.answer.split('').sort().join('');
      a.picked = picked; a.done = true; a.ok = ok && !a.viewed;
      ws.ex[ws.i] = '';
      flushQt();
      var pp = recordAnswer(q, ok, !a.viewed, picked, ws.qt[ws.i] || 0);
      if (pp) a.pp = pp;
      /* 连对计数：计分答对 +1，答错或已看解析归零；仅作答瞬间展示，回放不显 */
      ws.cb = (ok && !a.viewed) ? (ws.cb || 0) + 1 : 0;
      if (ws.cb > (ws.cbm || 0)) ws.cbm = ws.cb;
      verdict.innerHTML = '';
      paintDone(); paintSheet(); saveSession();
      if (ok && !a.viewed && ws.cb >= 3) {
        var cbEl = el('span', 'ml-2 shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-[12px] font-medium text-amber-700', '🔥 连对 ' + ws.cb);
        verdict.appendChild(cbEl);
      }
      if (autoNext && ok && !a.viewed && !ws.submitted && ws.i < qs.length - 1) {
        var from = ws.i;
        setTimeout(function () {
          if (ws.i !== from || ws.submitted) return;
          ws.i++; saveSession(); renderQ(true); paintSheet();
        }, 600);
      }
    }

    function wireHint() {
      if (!hintBtn) return;
      if (a.hint) { removeAct(hintBtn); return; }
      hintBtn.addEventListener('click', function () {
        a.hint = true;
        wrap.insertAdjacentElement('afterend', hintNode());
        removeAct(hintBtn);
        saveSession();
      });
    }

    if (a.done || ((browseOn() || ws.submitted) && !a.done)) {
      if (browseOn() && !ws.submitted && !a.done && !a.viewed) { a.viewed = true; }
      if (a.done) { paintDone(); }
      else {
        /* 背题模式/交卷后回看：直接亮答案与解析，不写记录 */
        buttons.forEach(function (b) {
          if (q.answer.indexOf(b.dataset.key) >= 0) markBtn(b, 'correct'); else markBtn(b, 'dim');
        });
        if (submitBtn) submitBtn.classList.add('hidden');
        revealP.remove();
        if (ws.submitted) {
          verdict.classList.remove('hidden'); verdict.classList.add('flex', 'border-amber-200', 'bg-amber-50');
          verdict.appendChild(el('p', 'text-sm font-medium text-amber-800', '本题未作答 · 正确答案 ' + q.answer));
        }
        col.appendChild(analysisNode(q));
      }
    } else if (deferMode) {
      /* 只记选择不判分：交卷时统一判分与落库 */
      var sel = (a.picked || []).slice();
      function paintSel() {
        buttons.forEach(function (b) {
          var on = sel.indexOf(b.dataset.key) >= 0;
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.classList.toggle('border-brand-600', on); b.classList.toggle('bg-brand-50', on);
          b.classList.toggle('ring-1', on); b.classList.toggle('ring-brand-600', on);
          b.classList.toggle('border-line', !on);
        });
      }
      paintSel();
      armExcl(function (k) {
        var ix = sel.indexOf(k);
        if (ix >= 0) { sel.splice(ix, 1); a.picked = sel.slice(); paintSel(); paintSheet(); }
      });
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          if (a.done || exclClick(b)) return;
          var k = b.dataset.key;
          if (!isMulti) sel = sel[0] === k ? [] : [k];
          else { var ix = sel.indexOf(k); if (ix >= 0) sel.splice(ix, 1); else sel.push(k); }
          a.picked = sel.slice();
          paintSel(); paintSheet(); saveSession();
          if (autoNext && !isMulti && sel.length > 0 && ws.i < qs.length - 1) {
            var from = ws.i;
            setTimeout(function () {
              if (ws.i !== from || ws.submitted) return;
              ws.i++; saveSession(); renderQ(true); paintSheet();
            }, 400);
          }
        });
      });
      if (submitBtn) submitBtn.classList.add('hidden');
      wireHint();
    } else {
      /* 多选未提交的勾选按题持久化（a.picked），切题/刷新不丢，答题卡计「已选待判分」，交卷时统一判分 */
      var picked = isMulti ? (a.picked || []).slice() : [];
      function paintPick(b, on) {
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.classList.toggle('border-brand-600', on); b.classList.toggle('bg-brand-50', on);
        b.classList.toggle('ring-1', on); b.classList.toggle('ring-brand-600', on);
        b.classList.toggle('border-line', !on);
      }
      function paintSubmit() {
        if (submitBtn) { submitBtn.classList.toggle('hidden', picked.length === 0); submitBtn.classList.toggle('flex', picked.length > 0); }
      }
      if (isMulti && picked.length > 0) {
        buttons.forEach(function (b) { paintPick(b, picked.indexOf(b.dataset.key) >= 0); });
        paintSubmit();
      }
      armExcl(function (k) {
        var ix = picked.indexOf(k);
        if (ix < 0) return;
        picked.splice(ix, 1);
        buttons.forEach(function (b) { if (b.dataset.key === k) paintPick(b, false); });
        paintSubmit(); a.picked = picked.slice(); paintSheet();
      });
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          if (a.done || exclClick(b)) return;
          var k = b.dataset.key;
          if (!isMulti) { finish([k]); return; }
          var i = picked.indexOf(k);
          if (i >= 0) picked.splice(i, 1); else picked.push(k);
          paintPick(b, i < 0);
          paintSubmit();
          a.picked = picked.slice();
          paintSheet(); saveSession();
        });
      });
      if (submitBtn) submitBtn.addEventListener('click', function () { if (!a.done && picked.length > 0) finish(picked); });
      wireHint();
      revealBtn.addEventListener('click', function () {
        a.viewed = true;
        col.appendChild(analysisNode(q));
        removeAct(revealBtn);
        saveSession();
      });
    }
    paintFav();
    paintMark();
    paintNav();
    window.scrollTo({ top: 0 });
    if (focusStem) { try { stem.focus({ preventScroll: true }); } catch (_) { stem.focus(); } }
  }

  /* ---------- 底栏 / 答题卡 / 收藏 ---------- */
  function paintNav() {
    $('ws-prev').disabled = ws.i === 0;
    var last = ws.i === qs.length - 1;
    $('ws-next').textContent = last ? '已是最后一题' : '下一题';
    $('ws-next').disabled = last;
    $('ws-next').hidden = last;
    var sub = $('ws-submit');
    sub.textContent = reviewing ? '返回报告' : '交卷';
    sub.classList.toggle('flex-1', last);
    sub.classList.toggle('shrink-0', !last);
    sub.classList.toggle('bg-brand-700', last);
    sub.classList.toggle('text-white', last);
    sub.classList.toggle('hover:bg-brand-800', last);
    sub.classList.toggle('bg-white', !last);
    sub.classList.toggle('text-brand-700', !last);
    sub.classList.toggle('hover:bg-brand-50', !last);
  }
  function paintMark() {
    var btn = $('ws-mark'); if (!btn) return;
    var on = ws.mk[ws.i] === 1;
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? '已标记本题，点击取消' : '标记本题，交卷前可在答题卡回查');
    btn.className = on ? 'grid size-11 shrink-0 place-items-center rounded-xl border border-amber-300 bg-amber-50 text-amber-700' : 'grid size-11 shrink-0 place-items-center rounded-xl border border-line bg-white text-muted hover:bg-slate-50';
    btn.querySelector('svg').setAttribute('fill', on ? 'currentColor' : 'none');
  }
  function paintFav() {
    var fav = $('ws-fav'); var p = '/q/' + qs[ws.i].slug + '/';
    var on = store.readList('tiku-fav').indexOf(p) >= 0;
    fav.setAttribute('aria-pressed', on ? 'true' : 'false');
    fav.setAttribute('aria-label', on ? '已收藏，点击取消' : '收藏本题');
    fav.className = on ? 'grid size-11 shrink-0 place-items-center rounded-xl border border-amber-300 bg-amber-50 text-amber-700' : 'grid size-11 shrink-0 place-items-center rounded-xl border border-line bg-white text-muted hover:bg-slate-50';
    fav.querySelector('svg').setAttribute('fill', on ? 'currentColor' : 'none');
  }
  /* ≥xl 常驻答题卡侧栏（styles.css body.ws-side #ws-sheet-panel）：题卡可见时按卷挂载，避免题间切换闪动；
     含材料题的卷（行测全真卷必含资料分析）分栏 64rem 与侧栏在 1280–1439 放不下，仍用底栏抽屉；
     ≥1440 挂 body.ws-mat：分栏收窄到 100vw-37rem，侧栏贴分栏右侧（styles.css body.ws-mat） */
  var SIDE_MAT_MQ = matchMedia('(min-width: 1440px)');
  function paintSide() {
    var mat = qs.some(function (q) { return Boolean(q.mat); });
    var side = !root.hidden && !ws.pa && qs.length > 0 && (!mat || SIDE_MAT_MQ.matches);
    document.body.classList.toggle('ws-side', side);
    document.body.classList.toggle('ws-mat', side && mat);
    /* 顶栏工具组（? 操作 / 草稿 / 夜间 / 设置）只在题卡可见时显示：组卷中 / 失败 / 报告页不露操作台工具 */
    var tools = $('ws-tools'); if (tools) tools.hidden = root.hidden;
  }
  if (SIDE_MAT_MQ.addEventListener) SIDE_MAT_MQ.addEventListener('change', paintSide);
  /* 跨科目整卷：答题卡遇到新科目插入跨列分组标题（无 subject 卷零变化） */
  function sheetGroupLabel(grid, q, i) {
    if (!q.subject || (i > 0 && qs[i - 1].subject === q.subject)) return;
    var n = 0;
    qs.forEach(function (x) { if (x.subject === q.subject) n++; });
    var lb = el('p', 'mt-1 text-[12px] font-medium text-muted first:mt-0', q.subject + ' · ' + n + ' 题');
    lb.style.gridColumn = '1 / -1';
    grid.appendChild(lb);
  }
  /* 答题卡图例随判分方式：交卷后统一判分（限时卷/设置开启）作答中只有「已选/未答」，交卷后才有对错 */
  function paintSheetLegend() {
    var lg = $('ws-sheet-legend'); if (!lg) return;
    var deferring = (defer || timed()) && !browseOn() && !ws.submitted;
    lg.textContent = '';
    function dot(cls, label, first) {
      var d = el('span', (first ? '' : 'ml-2 ') + 'inline-block size-2.5 rounded-full align-middle ' + cls);
      lg.appendChild(d); lg.appendChild(document.createTextNode(' ' + label + ' '));
    }
    if (deferring) { dot('bg-brand-700', '已选', true); } else { dot('bg-emerald-700', '对', true); dot('bg-red-600', '错'); }
    dot('border border-line bg-white', '未答');
  }
  function paintSheet() {
    paintSheetLegend();
    var grid = $('ws-sheet-grid'); grid.innerHTML = '';
    var answered = 0;
    qs.forEach(function (q, i) {
      sheetGroupLabel(grid, q, i);
      var a = ws.ans[i];
      var st = a.done ? (a.ok ? 'ok' : 'wrong') : (a.picked && a.picked.length > 0 ? 'sel' : 'blank');
      if (st !== 'blank') answered++;
      var b = el('button', '', String(i + 1));
      b.type = 'button';
      var cls = 'relative grid h-10 place-items-center rounded-lg text-sm font-medium tabular-nums ';
      cls += st === 'ok' ? 'bg-emerald-700 text-white' : st === 'wrong' ? 'bg-red-600 text-white' : st === 'sel' ? 'bg-brand-700 text-white' : 'border border-line bg-white text-slate-600';
      if (i === ws.i) { cls += ' ring-2 ring-brand-600 ring-offset-1'; b.setAttribute('aria-current', 'true'); }
      b.className = cls;
      b.tabIndex = i === ws.i ? 0 : -1;
      if (ws.mk[i] === 1) b.appendChild(el('span', 'absolute -right-0.5 -top-0.5 size-2 rounded-full bg-amber-400 ring-2 ring-white'));
      b.setAttribute('aria-label', '第 ' + (i + 1) + ' 题' + (st === 'ok' ? '，已答对' : st === 'wrong' ? '，答错' : st === 'sel' ? '，已选待判分' : '，未作答') + (ws.mk[i] === 1 ? '，已标记' : ''));
      b.addEventListener('click', function () {
        ws.i = i; saveSession(); renderQ(true); paintSheet();
        $('ws-sheet-panel').hidden = true;
        $('ws-sheet-btn').setAttribute('aria-expanded', 'false');
      });
      grid.appendChild(b);
    });
    $('ws-sheet-pct').textContent = Math.round(answered / qs.length * 100) + '%';
    paintSheetSummary(answered);
    followSheetCur();
  }
  /* ≥xl 常驻侧栏（body.ws-side）：当前格越出面板可视区时把面板滚到当前格居中（与题页 initQSide 同口径）；
     格在可视区内不动，抽屉态面板无几何直接返回（打开时由 focus() 滚入）。用 rect 算术不用 scrollIntoView：面板 fixed，不让文档跟着滚 */
  function followSheetCur() {
    if (!document.body.classList.contains('ws-side')) return;
    var panel = $('ws-sheet-panel'); var cur = $('ws-sheet-grid').querySelector('[aria-current]');
    if (!cur) return;
    var pr = panel.getBoundingClientRect(); if (pr.height === 0) return;
    var cr = cur.getBoundingClientRect();
    if (cr.top >= pr.top && cr.bottom <= pr.bottom) return;
    panel.scrollTop += cr.top - pr.top - (pr.height - cr.height) / 2;
  }
  /* 答题卡摘要：已答/未答计数 + 跳到下一未答（自当前题起环形查找） */
  function paintSheetSummary(answered) {
    var old = document.getElementById('ws-sheet-summary');
    if (old) old.remove();
    var grid = $('ws-sheet-grid');
    var un = qs.length - answered;
    var deferring = (defer || timed()) && !browseOn() && !ws.submitted;
    var row = el('div', 'mb-2 flex items-center gap-3');
    row.id = 'ws-sheet-summary';
    if (un === 0) {
      row.appendChild(el('p', 'text-[13px] font-medium text-emerald-700', '已全部作答'));
    } else {
      row.appendChild(el('p', 'text-[13px] text-muted', (deferring ? '已选 ' : '已答 ') + answered + ' / 共 ' + qs.length + ' · 未答 ' + un + ' 题'));
      if (!ws.submitted) {
        var jump = el('button', 'text-[13px] font-medium text-brand-700 hover:underline', '跳到下一未答 →');
        jump.type = 'button';
        jump.addEventListener('click', function () {
          for (var d = 1; d <= qs.length; d++) {
            var i = (ws.i + d) % qs.length;
            if (!ws.ans[i].done && !(ws.ans[i].picked && ws.ans[i].picked.length > 0)) {
              ws.i = i; saveSession(); renderQ(true); paintSheet();
              $('ws-sheet-panel').hidden = true;
              $('ws-sheet-btn').setAttribute('aria-expanded', 'false');
              return;
            }
          }
        });
        row.appendChild(jump);
      }
    }
    grid.parentNode.insertBefore(row, grid);
  }

  /* ---------- 计时 ---------- */
  /* 用时 = 现在 - 开始 - 累计暂停（po）- 进行中暂停（pa）；tick/交卷同源 */
  function usedMs() {
    return Date.now() - ws.start - (ws.po || 0) - (ws.pa ? Date.now() - ws.pa : 0);
  }
  /* 逐题用时：当前题自 qtEnter 起的停留累入 qt[qtCur]；暂停/交卷后不累计 */
  var qtCur = -1; var qtEnter = Date.now();
  function flushQt() {
    if (ws.pa || ws.submitted || qtCur < 0) { qtEnter = Date.now(); return; }
    var now = Date.now();
    ws.qt[qtCur] = (ws.qt[qtCur] || 0) + (now - qtEnter);
    qtEnter = now;
  }
  var timerStop = false;
  var tickN = 0;
  /* 限时预警：≤5 分钟琥珀、≤1 分钟红色脉冲（.ws-urgent 只在两档可读红之间变色，不动 opacity，任一帧对比度 ≥4.5）；aria-live 各档播报一次 */
  var warnStage = 0;
  function paintTimeWarn(t, left) {
    var stage = left <= 60 ? 2 : left <= 300 ? 1 : 0;
    if (stage === warnStage) return;
    warnStage = stage;
    t.className = stage === 2
      ? 'font-medium text-rose-700 ws-urgent'
      : stage === 1
        ? 'font-medium text-amber-700'
        : '';
    var live = $('ws-timer-live');
    if (live && stage > 0) {
      live.textContent = stage === 2 ? '剩余不足 1 分钟，时间到将自动交卷' : '剩余不足 5 分钟';
    }
  }
  /* 非限时计时文本恒为「用时 m:ss」（暂停态只变色不变宽，避免同组「暂停」按钮位移）；tick/togglePause 同源 */
  function paintTimer(t) {
    var used = Math.floor(usedMs() / 1000);
    t.textContent = '用时 ' + Math.floor(used / 60) + ':' + (used % 60 < 10 ? '0' : '') + (used % 60);
    t.classList.toggle('text-amber-700', ws.pa > 0);
  }
  function tick() {
    if (timerStop) return;
    flushQt();
    /* 每 5s 落一次会话，刷新后逐题用时最多丢 5s */
    if (++tickN % 5 === 0) saveSession();
    var t = $('ws-timer');
    if (ws.end) {
      var left = Math.ceil((ws.end - Date.now()) / 1000);
      if (left <= 0) {
        /* 到点自动交卷：标记随会话持久化，报告（含刷新恢复）明示「时间到」而非让用户以为误触交卷 */
        ws.to = 1;
        var tl = $('ws-timer-live');
        if (tl) { tl.textContent = ''; tl.textContent = '时间到，已自动交卷，正在显示成绩报告'; }
        submitPaper(true);
        return;
      }
      paintTimeWarn(t, left);
      var m = Math.floor(left / 60); var s = left % 60;
      t.textContent = '剩余 ' + m + ':' + (s < 10 ? '0' : '') + s;
    } else {
      paintTimer(t);
    }
    setTimeout(tick, 1000);
  }

  /* ---------- 回看全卷解析（交卷后只读） ---------- */
  /* 回看态：底栏「交卷」位改为「返回报告」（交卷后 submitPaper 直接 return，原为死按钮），暂停入口收起 */
  var reviewing = false;
  function exitReview() {
    reviewing = false;
    root.hidden = true; paintSide();
    $('ws-nav').classList.add('hidden');
    $('ws-sheet-panel').hidden = true;
    document.body.classList.remove('pb-24');
    $('ws-report').hidden = false;
    window.scrollTo({ top: 0 });
  }
  function enterReview() {
    reviewing = true;
    $('ws-report').hidden = true;
    var bar = $('ws-review-bar');
    if (!bar) {
      bar = el('div', 'mb-4 flex flex-wrap items-center justify-between gap-2 rounded-xl border border-brand-200 bg-brand-50 px-4 py-2.5');
      bar.id = 'ws-review-bar';
      bar.appendChild(el('p', 'text-sm font-medium text-brand-800', '回看模式 · 已交卷，作答不可修改'));
      /* 有错题时提供环形「下一错题」定位（与复盘列表同口径 ok !== true） */
      var wrongIdx = [];
      ws.ans.forEach(function (a, i) { if (a.ok !== true) wrongIdx.push(i); });
      if (wrongIdx.length > 0 && wrongIdx.length < qs.length) {
        var nw = el('button', 'inline-flex h-10 shrink-0 items-center rounded-lg border border-brand-300 bg-white px-3.5 text-sm font-medium text-brand-700 hover:bg-brand-50', '下一错题 →');
        nw.type = 'button';
        nw.id = 'ws-next-wrong';
        nw.addEventListener('click', function () {
          var next = wrongIdx.filter(function (i) { return i > ws.i; })[0];
          ws.i = typeof next === 'number' ? next : wrongIdx[0];
          renderQ(); paintSheet();
          window.scrollTo({ top: 0 });
        });
        bar.appendChild(nw);
      }
      var back = el('button', 'inline-flex h-10 shrink-0 items-center rounded-lg bg-brand-700 px-3.5 text-sm font-medium text-white hover:bg-brand-800', '返回报告');
      back.type = 'button';
      back.addEventListener('click', exitReview);
      bar.appendChild(back);
      root.insertBefore(bar, root.firstChild);
    }
    $('ws-timer').textContent = '已交卷';
    $('ws-pause').classList.add('hidden');
    root.hidden = false; paintSide();
    $('ws-nav').classList.remove('hidden');
    document.body.classList.add('pb-24');
    renderQ(); paintSheet();
  }

  /* ---------- 交卷与报告 ---------- */
  function submitPaper(auto) {
    if (ws.submitted && !auto) return;
    var restoring = ws.submitted;
    if (!auto) {
      var un = ws.ans.filter(function (a) { return !a.done && !(a.picked && a.picked.length > 0); }).length;
      var msg = un > 0 ? '还有 ' + un + ' 题未作答，确定交卷？' : '确定交卷查看报告？';
      if (!window.confirm(msg)) return;
    }
    if (!restoring) flushQt();
    /* 交卷后统一判分：把已选未判的题统一判分并落库（契约与即时判分同路径）；全站计数整卷一次上报 */
    if (!restoring) {
      attemptBatch = [];
      try {
        qs.forEach(function (q, i) {
          var da = ws.ans[i];
          if (da.done || !da.picked || da.picked.length === 0) return;
          var dok = da.picked.slice().sort().join('') === q.answer.split('').sort().join('');
          da.done = true; da.ok = dok && !da.viewed;
          var dpp = recordAnswer(q, dok, !da.viewed, da.picked, ws.qt[i] || 0);
          if (dpp) da.pp = dpp;
        });
      } finally { flushAttempts(); }
    }
    ws.submitted = true; timerStop = true;
    /* 已交卷的卷不再是首页「继续上次练习」候选 */
    if (!restoring) {
      var lastRec = store.read('tiku-last', 'null');
      if (lastRec && lastRec.u === location.pathname + location.search + HXS) {
        try { localStorage.removeItem('tiku-last'); } catch (_) { /* noop */ }
      }
    }
    /* 用时只在首次交卷时计算并随会话持久化（可为 0），恢复重绘直接复用，报告与 tiku-hist 同源 */
    var used = restoring ? (ws.used || 0) : Math.min(Math.floor(usedMs() / 1000), ws.end ? Math.floor((ws.end - ws.start) / 1000) : Infinity);
    ws.used = used;
    saveSession();
    root.hidden = true; paintSide();
    $('ws-nav').classList.add('hidden');
    $('ws-sheet-panel').hidden = true;
    document.body.classList.remove('pb-24');
    /* 三分口径：答对 / 答错 / 未答（未答 = 交卷时未选，done 仍为 false）；分数仍按 0 分计 */
    function isUn(i) { return ws.ans[i].done !== true; }
    var okN = 0; var unN = 0; var wrongQ = [];
    qs.forEach(function (q, i) {
      if (ws.ans[i].ok === true) okN++;
      else { wrongQ.push(q); if (isUn(i)) unN++; }
    });
    var pct = Math.round(okN / qs.length * 100);
    function unSuffix(k) { return k > 0 ? ' · 未答 ' + k : ''; }
    /* 练习历史：每卷只记一次（含限时自动交卷）；恢复已交卷会话重绘报告不重复记 */
    if (!ws.hist && !restoring) {
      var hist = store.read('tiku-hist', '[]');
      if (!Array.isArray(hist)) hist = [];
      /* 近 10 卷个人正确率均值：交卷前快照（不含本卷），随会话持久化供回显；只与同模式卷比（无 m 的旧记录保留） */
      var pavPrev = hist.filter(function (h) { return h && h.n > 0 && (!h.m || h.m === meta.mode); }).slice(0, 10);
      if (pavPrev.length >= 3) {
        ws.pavg = Math.round(pavPrev.reduce(function (a, h) { return a + h.ok / h.n * 100; }, 0) / pavPrev.length);
        ws.pavgn = pavPrev.length;
      }
      ws.hist = 1; saveSession();
      hist.unshift({ d: Math.floor(Date.now() / 1000), s: meta.title, m: meta.mode, n: qs.length, ok: okN, un: unN, u: used, q: qs.slice(0, 150).map(function (q) { return q.slug; }), w: wrongQ.slice(0, 150).map(function (q) { return q.slug; }) });
      if (hist.length > 50) hist.length = 50;
      store.write('tiku-hist', hist);
      /* 全时计数器（tiku-stats p 卷数 / f 满分卷 / u 秒）：tiku-hist 只留 50 条、tiku-mins 只留 126 天，成就「练习场次/满分卷」与统计「练习时长」不能只靠窗口内求和 */
      var stAll = store.read('tiku-stats', '{"a":0,"c":0}');
      stAll.p = (stAll.p || 0) + 1;
      if (okN === qs.length && qs.length >= 5) stAll.f = (stAll.f || 0) + 1;
      stAll.u = (stAll.u || 0) + Math.min(used, 14400);
      store.write('tiku-stats', stAll);
      /* 每日练习时长（tiku-mins：逐日秒数，与报告用时同口径，单卷封顶 4 小时，保留 126 天） */
      var minsMap = store.read('tiku-mins', '{}');
      var mk = localDay(new Date());
      minsMap[mk] = (minsMap[mk] || 0) + Math.min(used, 14400);
      var mkeys = Object.keys(minsMap).sort();
      while (mkeys.length > 126) { delete minsMap[mkeys.shift()]; }
      store.write('tiku-mins', minsMap);
    }
    $('ws-score').textContent = pct + ' 分';
    var CIRC = 2 * Math.PI * 52;
    requestAnimationFrame(function () { $('ws-ring').setAttribute('stroke-dasharray', (CIRC * pct / 100) + ' ' + CIRC); });
    $('ws-correct').textContent = okN + '/' + qs.length;
    $('ws-time').textContent = Math.floor(used / 60) + ' 分 ' + (used % 60) + ' 秒';
    /* 平均每题按已答题数计（未答题没有停留时长，全题数为分母会把 25 题答 3 题算成 8 秒/题） */
    var ansN = qs.length - unN;
    var avgSec = Math.round(used / (ansN > 0 ? ansN : qs.length));
    $('ws-avg').textContent = ansN > 0 ? avgSec + ' 秒' : '—';
    var avgLbl = $('ws-avg').nextElementSibling;
    if (avgLbl) avgLbl.textContent = '平均每题';
    var statsRow = $('ws-correct') && $('ws-correct').parentNode ? $('ws-correct').parentNode.parentNode : null;
    /* 未答拆分 + 平均口径：统计行下独占一行（塞进 62/96 宽的列会折成两行） */
    if (unN > 0 && !$('ws-split') && statsRow && statsRow.parentNode) {
      var sl = el('p', 'mt-2 text-center text-[11px] text-muted tabular-nums', '答错 ' + (qs.length - okN - unN) + ' · 未答 ' + unN + (ansN > 0 ? ' · 平均按已答 ' + ansN + ' 题计' : ''));
      sl.id = 'ws-split';
      statsRow.parentNode.insertBefore(sl, statsRow.nextSibling);
    }
    /* 限时到点自动交卷：统计行下明示原因（恢复重绘同样显示） */
    if (ws.to && !$('ws-timeup') && statsRow && statsRow.parentNode) {
      var tu = el('p', 'mt-2 text-center text-[12px] font-medium text-amber-700', '⏱ 时间到，已自动交卷' + (unN > 0 ? ' · 未答 ' + unN + ' 题按 0 分计' : ''));
      tu.id = 'ws-timeup';
      tu.setAttribute('role', 'status');
      statsRow.parentNode.insertBefore(tu, statsRow.nextSibling);
    }
    /* 近 10 卷平均正确率参照：统计行下独占一行（≥3 卷历史才显示，±5pp 加徽标） */
    if (ws.pavg > 0 && !$('ws-prev-acc')) {
      if (statsRow && statsRow.parentNode) {
        var pl = el('p', 'mt-2 text-center text-[11px] text-muted tabular-nums', '近 ' + ws.pavgn + ' 卷同类平均 ' + ws.pavg + '%');
        pl.id = 'ws-prev-acc';
        if (pct >= ws.pavg + 5) pl.appendChild(el('span', 'ml-1 rounded-full bg-emerald-100 px-1.5 py-0.5 text-[11px] font-medium text-emerald-700', '进步'));
        else if (pct <= ws.pavg - 5) pl.appendChild(el('span', 'ml-1 rounded-full bg-amber-100 px-1.5 py-0.5 text-[11px] font-medium text-amber-700', '退步'));
        var afterSplit = $('ws-split') || statsRow;
        afterSplit.parentNode.insertBefore(pl, afterSplit.nextSibling);
      }
    }
    /* 每日一练打卡反馈：交卷即打卡成功，报告显示连续天数 */
    if (meta.mode === 'daily' && !$('ws-streak')) {
      var stk = dailyStreak();
      if (stk > 0) {
        var elBt = $('ws-beat');
        if (elBt && elBt.parentNode) {
          var sp = document.createElement('p');
          sp.id = 'ws-streak';
          sp.className = 'mt-3 rounded-full bg-amber-50 px-3 py-1 text-[13px] font-medium text-amber-700';
          sp.textContent = '✓ 打卡成功 · 已连续打卡 ' + stk + ' 天 🔥';
          elBt.parentNode.insertBefore(sp, elBt);
        }
      }
    }
    /* 最长连对：报告回显本卷最长连对并落库 tiku-combo（取 max） */
    if (ws.cbm >= 3 && !$('ws-combo')) {
      var prevCombo = store.read('tiku-combo', '0') || 0;
      if (ws.cbm > prevCombo) store.write('tiku-combo', ws.cbm);
      var elBc = $('ws-beat');
      if (elBc && elBc.parentNode) {
        var cp = document.createElement('p');
        cp.id = 'ws-combo';
        cp.className = 'mt-3 rounded-full bg-amber-50 px-3 py-1 text-[13px] font-medium text-amber-700';
        cp.textContent = '🔥 本卷最长连对 ' + ws.cbm + ' 题' + (ws.cbm > prevCombo ? ' · 🎉 新纪录' : '');
        elBc.parentNode.insertBefore(cp, elBc);
      }
    }
    /* 今日刷题进度：报告贯通首页今日目标/备考计划（tiku-days + tiku-plan/tiku-goal，纯本地） */
    if (!$('ws-today')) {
      var tdDays = store.read('tiku-days', '{}');
      var tdN = tdDays[localDay(new Date())] || 0;
      if (tdN > 0) {
        var tdPlan = store.read('tiku-plan', 'null');
        var tdPm = tdPlan && tdPlan.e && tdPlan.s && tdPlan.g > 0 ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(tdPlan.d || '') : null;
        var tdNow = new Date();
        var tdPlanOk = !!tdPm && (new Date(+tdPm[1], +tdPm[2] - 1, +tdPm[3]) - new Date(tdNow.getFullYear(), tdNow.getMonth(), tdNow.getDate())) >= 0;
        var tdGoal = parseInt(store.read('tiku-goal', '20'), 10);
        var tdG = tdPlanOk ? tdPlan.g : ([10, 20, 50].indexOf(tdGoal) >= 0 ? tdGoal : 20);
        var elBd = $('ws-beat');
        if (elBd && elBd.parentNode) {
          var tp = document.createElement('p');
          tp.id = 'ws-today';
          var tdHit = tdN >= tdG;
          tp.className = 'mt-3 rounded-full px-3 py-1 text-[13px] font-medium ' + (tdHit ? 'bg-emerald-50 text-emerald-700' : 'bg-slate-100 text-slate-600');
          tp.textContent = '今日已刷 ' + tdN + ' / ' + (tdPlanOk ? '计划' : '目标') + ' ' + tdG + ' 题' + (tdHit ? ' · 达成 ✓' : ' · 还差 ' + (tdG - tdN) + ' 题');
          /* 无有效备考计划（含从未制定 / 已过期）：「目标 20」只是默认值，报告就地给出制定计划的入口，不必回首页找 */
          if (!tdPlanOk) {
            tp.appendChild(document.createTextNode(' '));
            var tpS = el('span', 'whitespace-nowrap', '· ');
            var tpA = document.createElement('a');
            tpA.href = '/my/#plan-card';
            tpA.className = 'tap-y inline-flex items-center font-medium text-brand-700 underline underline-offset-2';
            tpA.textContent = tdPm ? '重设备考计划 →' : '制定备考计划 →';
            tpS.appendChild(tpA);
            tp.appendChild(tpS);
          }
          elBd.parentNode.insertBefore(tp, elBd);
        }
      }
    }
    /* 固定卷成绩分布：匿名上报百分制得分，展示击败百分比（每卷只报一次，恢复会话直接用存档）；
       pending=true 时按同一文案形态占位（数字位「–」），POST 回来后原地改文案不改几何 */
    function paintBeat(r, pending) {
      var elB = $('ws-beat');
      if (!elB || !r || (!pending && typeof r.beat !== 'number')) return;
      var sk = meta.scoreKey || '';
      var num = function (v) { return pending ? '–' : v; };
      /* 只有自己一份成绩（n≤1，含预取占位 preN≤1）：「击败了 0% · 共 1 人」是无意义的对比，改写为首位交卷；占位与终态同文案，揭示后不换行数 */
      elB.textContent = Number(r.n) <= 1 ? (sk.indexOf('daily:') === 0 ? '今日' : sk.indexOf('weekly:') === 0 ? '本周' : '本卷') + '首位交卷 · 得分 ' + pct + ' 分 · 暂无同卷对比' + (r.qa ? '（QA 模式，本次不计入）' : '') : (pending || typeof r.rank === 'number' ? (sk.indexOf('daily:') === 0 ? '今日第 ' : sk.indexOf('weekly:') === 0 ? '本周第 ' : '本卷第 ') + num(r.rank) + ' 名 · ' : '') + '击败了 ' + num(r.beat) + '% 的刷题人 · 共 ' + r.n + ' 人交卷' + (pending || typeof r.avg === 'number' ? ' · 平均 ' + num(r.avg) + ' 分' : '') + (r.qa ? '（QA 模式，本次不计入统计）' : '');
      if (pending) elB.setAttribute('aria-busy', 'true'); else elB.removeAttribute('aria-busy');
      var wkm = /^weekly:([\w-]+):/.exec(sk) || /^mockline:([\w-]+):(\d)$/.exec(sk);
      var mkm = wkm ? null : /^mock:([\w-]+):([\w-]+):(\d)$/.exec(sk);
      if ((wkm || mkm) && !elB.querySelector('a')) {
        var lnk = document.createElement('a');
        lnk.href = mkm ? '/mock/' + mkm[1] + '/' + mkm[2] + '/?paper=' + mkm[3] : '/mock/' + wkm[1] + '/?paper=' + (wkm[2] || 'w');
        lnk.className = 'tap-y ml-1 inline-flex items-center font-medium text-brand-700 underline underline-offset-2';
        lnk.textContent = mkm || wkm[2] ? '查看本卷排行榜 →' : '查看本周排行榜 →';
        elB.appendChild(document.createTextNode(' '));
        elB.appendChild(lnk);
      }
      elB.hidden = false;
    }
    /* 本卷分数分布：稳定 scoreKey 卷拉取十桶直方图，自己所在桶高亮（n<3 样本过小不显示；首次交卷在上报完成后拉取，保证含自己） */
    var distMine = Math.min(Math.floor(pct / 10), 9);
    function paintDistBars(buckets) {
      var bars = $('ws-dist-bars'); if (!bars) return;
      var max = Math.max.apply(null, buckets);
      bars.textContent = '';
      for (var bi = 0; bi < 10; bi++) {
        var bar = document.createElement('div');
        bar.className = 'flex-1 rounded-t ' + (bi === distMine ? 'bg-brand-600' : 'bg-slate-200');
        bar.style.height = Math.max(4, Math.round(buckets[bi] / max * 100)) + '%';
        bar.title = bi * 10 + '–' + (bi === 9 ? 100 : bi * 10 + 9) + ' 分：' + buckets[bi] + ' 人';
        bars.appendChild(bar);
      }
    }
    /* 已知样本 ≥3 时同步占位：有开卷预取桶（pre）就直接画真实形状（本人桶 +1），否则平底柱；直方图到达后只改柱高不推动下方内容 */
    function showDistShell(pre) {
      var bars = $('ws-dist-bars'); if (!bars || !$('ws-dist')) return;
      if (pre && Array.isArray(pre.buckets) && pre.buckets.length === 10) {
        var pb = pre.buckets.slice(); pb[distMine] += 1;
        paintDistBars(pb);
      } else if (!bars.children.length) {
        for (var si = 0; si < 10; si++) {
          var sb = document.createElement('div');
          sb.className = 'flex-1 rounded-t ' + (si === distMine ? 'bg-brand-600' : 'bg-slate-200');
          sb.style.height = '4%';
          bars.appendChild(sb);
        }
      }
      $('ws-dist-note').textContent = '你在 ' + distMine * 10 + '–' + (distMine === 9 ? 100 : distMine * 10 + 9) + ' 分段';
      $('ws-dist').hidden = false;
    }
    function loadDist(fresh) {
      if (!meta.scoreKey || !$('ws-dist')) return;
      try {
        fetch('/api/paper-score?key=' + encodeURIComponent(meta.scoreKey), fresh ? { cache: 'no-cache' } : undefined)
          .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
          .then(function (d) {
            if (!d || !Array.isArray(d.buckets) || d.buckets.length !== 10 || d.n < 3) { $('ws-dist').hidden = true; return; }
            paintDistBars(d.buckets);
            $('ws-dist-note').textContent = '你在 ' + distMine * 10 + '–' + (distMine === 9 ? 100 : distMine * 10 + 9) + ' 分段';
            $('ws-dist').hidden = false;
          })
          .catch(function () { $('ws-dist').hidden = true; });
      } catch (_) { /* noop */ }
    }
    /* 报告揭示：首次交卷的排名 pill 与分布占位若在揭示后才插入会把下方内容推开（375 实测 CLS 0.13）。
       开卷预取 psPre 可用 → 同步按最终形态占位（排名「–」+ 预取桶直方图）并立即揭示，POST 回来只原地改文案/柱高；
       预取不可用 → 回退等 POST，最多 600ms，超时/失败照常揭示 */
    var revealed = false;
    function revealReport() {
      if (revealed) return;
      revealed = true;
      $('ws-report').hidden = false;
      window.scrollTo({ top: 0 });
    }
    var revealWait = false;
    if (ws.psr) {
      paintBeat(ws.psr);
      if (ws.psr.n >= 3) showDistShell();
      loadDist();
    } else if (meta.scoreKey && !ws.ps) {
      ws.ps = 1; saveSession();
      try {
        if (psPre) {
          var preN = psPre.n + (qaOn() ? 0 : 1);
          paintBeat({ n: preN, qa: qaOn() ? true : undefined }, true);
          if (preN >= 3) showDistShell(psPre);
        } else {
          revealWait = true;
          setTimeout(revealReport, 600);
        }
        fetch('/api/paper-score', {
          method: 'POST',
          headers: postHeaders(),
          body: JSON.stringify({ key: meta.scoreKey, pct: pct, nick: (localStorage.getItem('tiku-nick') || '').slice(0, 12), qa: qaOn() || undefined })
        }).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
          .then(function (d) {
            ws.psr = { n: d.n, beat: d.beat, avg: d.avg, rank: d.rank, qa: d.qa === true || undefined }; saveSession(); paintBeat(ws.psr);
            if (d.n >= 3) showDistShell();
            revealReport();
            loadDist(true);
            if (typeof d.rank === 'number') {
              try {
                var rk = JSON.parse(localStorage.getItem('tiku-rank') || '{}');
                rk[meta.scoreKey] = { r: d.rank, p: pct, t: Math.floor(Date.now() / 1000) };
                var keys = Object.keys(rk);
                if (keys.length > 40) {
                  keys.sort(function (a, b) { return (rk[a].t || 0) - (rk[b].t || 0); });
                  keys.slice(0, keys.length - 40).forEach(function (k) { delete rk[k]; });
                }
                localStorage.setItem('tiku-rank', JSON.stringify(rk));
              } catch (_) { /* noop */ }
            }
          })
          .catch(function () { revealReport(); /* 静默：不阻塞报告 */ });
      } catch (_) { revealWait = false; }
    }
    /* 历史成绩对比：固定卷（scoreKey 卷，题集稳定可比）按卷名读 tiku-hist，随机/自选卷不启用 */
    (function () {
      var elP = $('ws-prev-score');
      if (!elP || !meta.scoreKey) return;
      var hist = store.read('tiku-hist', '[]');
      if (!Array.isArray(hist)) return;
      var mine = hist.filter(function (h) { return h && h.s === meta.title && h.n > 0; });
      if (mine.length < 2) return;
      var prevPct = Math.round(mine[1].ok / mine[1].n * 100);
      var best = 0;
      mine.forEach(function (h) { var p = Math.round(h.ok / h.n * 100); if (p > best) best = p; });
      var diff = pct - prevPct;
      var word = diff > 0 ? '较上次 +' + diff + ' 分' : diff < 0 ? '较上次 −' + (-diff) + ' 分' : '与上次持平';
      elP.textContent = '';
      elP.appendChild(el('span', '', '第 ' + mine.length + ' 次作答 · '));
      elP.appendChild(el('span', diff > 0 ? 'font-medium text-emerald-700' : diff < 0 ? 'font-medium text-rose-600' : 'font-medium', word));
      elP.appendChild(el('span', '', '（上次 ' + prevPct + ' 分） · 历史最高 ' + best + ' 分'));
      elP.hidden = false;
    })();
    /* 知识点正确率（数据已在整卷负载内，零请求聚合） */
    var agg = {}; var order = [];
    qs.forEach(function (q, i) {
      var kpsQ = (q.kps || []);
      var names = kpsQ.map(function (k) { return k.name; });
      if (names.length === 0) names = ['未归类'];
      names.forEach(function (nm, j) {
        if (!agg[nm]) {
          var href = kpsQ[j] && typeof kpsQ[j].href === 'string' && /^\/kaoshi\/[\w-]+\/[\w-]+\/kp\/[\w-]+\/$/.test(kpsQ[j].href) ? kpsQ[j].href : '';
          agg[nm] = { ok: 0, total: 0, un: 0, wrong: [], href: href };
          order.push(nm);
        }
        agg[nm].total++;
        if (ws.ans[i].ok === true) agg[nm].ok++;
        else {
          if (isUn(i)) agg[nm].un++;
          if (agg[nm].wrong.length < 20) agg[nm].wrong.push(q.slug);
        }
      });
    });
    /* 二级题型考点「父名·子名」与父考点同现时归为父行下的子行（雷达只取父/无父行），不重复计一次作答（docs/plan-r528） */
    var kpParentOf = {};
    order.forEach(function (nm) {
      order.forEach(function (o) { if (o !== nm && nm.indexOf(o + '·') === 0 && (!kpParentOf[nm] || o.length > kpParentOf[nm].length)) kpParentOf[nm] = o; });
    });
    /* 分科目成绩：跨科目整卷按科目细分正确率，≥2 个科目才显示（单科卷不显示） */
    (function () {
      var sec = $('ws-subj-sec'), slist = $('ws-subj-list');
      if (!sec || !slist) return;
      var sagg = {}; var sorder = [];
      qs.forEach(function (q, i) {
        var nm = q.subject;
        if (!nm) return;
        if (!sagg[nm]) { sagg[nm] = { ok: 0, total: 0, un: 0, t: 0, wrong: [] }; sorder.push(nm); }
        sagg[nm].total++;
        sagg[nm].t += ws.qt[i] || 0;
        if (ws.ans[i].ok === true) sagg[nm].ok++;
        else {
          if (isUn(i)) sagg[nm].un++;
          if (sagg[nm].wrong.length < 25) sagg[nm].wrong.push(q.slug);
        }
      });
      if (sorder.length < 2) return;
      sorder.sort(function (a, b) { return sagg[a].ok / sagg[a].total - sagg[b].ok / sagg[b].total; });
      slist.innerHTML = '';
      sorder.forEach(function (nm) {
        var p3 = Math.round(sagg[nm].ok / sagg[nm].total * 100);
        var row = el('div', '');
        var head = el('div', 'flex flex-wrap items-baseline justify-between gap-x-2 gap-y-0.5 text-[13px]');
        head.appendChild(el('span', 'truncate font-medium text-slate-700', nm));
        var right = el('span', 'ml-auto flex shrink-0 items-baseline gap-2');
        var t3 = Math.round(sagg[nm].t / 1000);
        right.appendChild(el('span', 'text-muted tabular-nums', sagg[nm].ok + '/' + sagg[nm].total + ' · ' + p3 + '%' + unSuffix(sagg[nm].un) + (t3 > 0 ? ' · ' + (t3 >= 60 ? Math.floor(t3 / 60) + '分' + (t3 % 60) + '秒' : t3 + '秒') : '')));
        if (sagg[nm].wrong.length > 0) {
          var drill = el('a', 'inline-flex min-h-10 items-center font-medium text-brand-700 hover:underline', '重刷 →');
          drill.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(sagg[nm].wrong.join(','));
          right.appendChild(drill);
        }
        head.appendChild(right);
        var track = el('div', 'mt-1 h-2 overflow-hidden rounded-full bg-slate-100');
        var bar = el('div', 'h-full rounded-full ' + (p3 >= 80 ? 'bg-emerald-500' : p3 >= 50 ? 'bg-amber-400' : 'bg-red-400'));
        bar.style.width = p3 + '%';
        track.appendChild(bar);
        row.appendChild(head);
        row.appendChild(track);
        slist.appendChild(row);
      });
      sec.hidden = false;
    })();
    /* 难度分析：按难度分档（易 1–2 / 中 3 / 难 4–5）正确率，≥2 个档位有题才显示 */
    (function () {
      var sec = $('ws-diff-sec'), dlist = $('ws-diff-list');
      if (!sec || !dlist) return;
      var bands = [
        { name: '易（难度 1–2）', ok: 0, total: 0, un: 0, wrong: [] },
        { name: '中（难度 3）', ok: 0, total: 0, un: 0, wrong: [] },
        { name: '难（难度 4–5）', ok: 0, total: 0, un: 0, wrong: [] }
      ];
      qs.forEach(function (q, i) {
        var d = Number(q.difficulty);
        if (!(d >= 1)) return;
        var b = bands[d <= 2 ? 0 : d <= 3 ? 1 : 2];
        b.total++;
        if (ws.ans[i].ok === true) b.ok++;
        else {
          if (isUn(i)) b.un++;
          if (b.wrong.length < 25) b.wrong.push(q.slug);
        }
      });
      var used = bands.filter(function (b) { return b.total > 0; });
      if (used.length < 2) return;
      dlist.innerHTML = '';
      used.forEach(function (b) {
        var p3 = Math.round(b.ok / b.total * 100);
        var row = el('div', '');
        var head = el('div', 'flex flex-wrap items-baseline justify-between gap-x-2 gap-y-0.5 text-[13px]');
        head.appendChild(el('span', 'truncate font-medium text-slate-700', b.name));
        var right = el('span', 'ml-auto flex shrink-0 items-baseline gap-2');
        right.appendChild(el('span', 'text-muted tabular-nums', b.ok + '/' + b.total + ' · ' + p3 + '%' + unSuffix(b.un)));
        if (b.wrong.length > 0) {
          var drill = el('a', 'inline-flex min-h-10 items-center font-medium text-brand-700 hover:underline', '重刷 →');
          drill.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(b.wrong.join(','));
          right.appendChild(drill);
        }
        head.appendChild(right);
        var track = el('div', 'mt-1 h-2 overflow-hidden rounded-full bg-slate-100');
        var bar = el('div', 'h-full rounded-full ' + (p3 >= 80 ? 'bg-emerald-500' : p3 >= 50 ? 'bg-amber-400' : 'bg-red-400'));
        bar.style.width = p3 + '%';
        track.appendChild(bar);
        row.appendChild(head);
        row.appendChild(track);
        dlist.appendChild(row);
      });
      sec.hidden = false;
    })();
    /* 题型分析：按题型（单选/多选/判断）正确率，≥2 个题型有题才显示 */
    (function () {
      var sec = $('ws-qtype-sec'), tlist = $('ws-qtype-list');
      if (!sec || !tlist) return;
      var tagg = {}; var torder = [];
      qs.forEach(function (q, i) {
        var nm = QTYPE[q.qtype] || q.qtype;
        if (!nm) return;
        if (!tagg[nm]) { tagg[nm] = { ok: 0, total: 0, un: 0, wrong: [] }; torder.push(nm); }
        tagg[nm].total++;
        if (ws.ans[i].ok === true) tagg[nm].ok++;
        else {
          if (isUn(i)) tagg[nm].un++;
          if (tagg[nm].wrong.length < 25) tagg[nm].wrong.push(q.slug);
        }
      });
      if (torder.length < 2) return;
      torder.sort(function (a, b) { return tagg[a].ok / tagg[a].total - tagg[b].ok / tagg[b].total; });
      tlist.innerHTML = '';
      torder.forEach(function (nm) {
        var p3 = Math.round(tagg[nm].ok / tagg[nm].total * 100);
        var row = el('div', '');
        var head = el('div', 'flex flex-wrap items-baseline justify-between gap-x-2 gap-y-0.5 text-[13px]');
        head.appendChild(el('span', 'truncate font-medium text-slate-700', nm));
        var right = el('span', 'ml-auto flex shrink-0 items-baseline gap-2');
        right.appendChild(el('span', 'text-muted tabular-nums', tagg[nm].ok + '/' + tagg[nm].total + ' · ' + p3 + '%' + unSuffix(tagg[nm].un)));
        if (tagg[nm].wrong.length > 0) {
          var drill = el('a', 'inline-flex min-h-10 items-center font-medium text-brand-700 hover:underline', '重刷 →');
          drill.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(tagg[nm].wrong.join(','));
          right.appendChild(drill);
        }
        head.appendChild(right);
        var track = el('div', 'mt-1 h-2 overflow-hidden rounded-full bg-slate-100');
        var bar = el('div', 'h-full rounded-full ' + (p3 >= 80 ? 'bg-emerald-500' : p3 >= 50 ? 'bg-amber-400' : 'bg-red-400'));
        bar.style.width = p3 + '%';
        track.appendChild(bar);
        row.appendChild(head);
        row.appendChild(track);
        tlist.appendChild(row);
      });
      sec.hidden = false;
    })();
    /* 考点能力雷达：3–8 个考点时绘制（>8 取题量最多的前 8），纯 SVG 零依赖 */
    var radarCtx = null;
    (function () {
      var box = $('ws-radar'); if (!box) return;
      var axes = order.filter(function (nm) { return !kpParentOf[nm]; });
      if (axes.length > 8) { axes.sort(function (a, b) { return agg[b].total - agg[a].total; }); axes = axes.slice(0, 8); }
      if (axes.length < 3) return;
      var NS = 'http://www.w3.org/2000/svg';
      /* 轴标签不进 SVG（随 viewBox 缩放 375 只剩 9px 且 6 字截断），改为包裹层上按百分比绝对定位的 HTML span：字号固定、CSS truncate、title 全名 */
      var W = 360, H = 280, cx = W / 2, cy = H / 2 + 6, R = 92;
      var wrap = el('div', 'relative');
      function pt(i, r) {
        var a = -Math.PI / 2 + i * 2 * Math.PI / axes.length;
        return [cx + r * Math.cos(a), cy + r * Math.sin(a)];
      }
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      svg.setAttribute('overflow', 'visible');
      svg.setAttribute('class', 'block w-full');
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', '考点正确率雷达图');
      [0.25, 0.5, 0.75, 1].forEach(function (f) {
        var g = document.createElementNS(NS, 'polygon');
        g.setAttribute('points', axes.map(function (_, i) { return pt(i, R * f).join(','); }).join(' '));
        g.setAttribute('fill', 'none');
        g.setAttribute('stroke', '#cbd5e1');
        g.setAttribute('stroke-width', f === 1 ? '1.2' : '0.7');
        svg.appendChild(g);
      });
      axes.forEach(function (nm, i) {
        var p = pt(i, R);
        var ln = document.createElementNS(NS, 'line');
        ln.setAttribute('x1', cx); ln.setAttribute('y1', cy);
        ln.setAttribute('x2', p[0]); ln.setAttribute('y2', p[1]);
        ln.setAttribute('stroke', '#cbd5e1'); ln.setAttribute('stroke-width', '0.7');
        svg.appendChild(ln);
        var lp = pt(i, R + 14);
        var side = lp[0] < cx - 8 ? 'end' : lp[0] > cx + 8 ? 'start' : 'middle';
        var lab = el('span', 'absolute max-w-[7em] truncate text-[11px] leading-tight text-muted', nm.replace(/[（(][^）)]*[）)]/g, '').trim() || nm);
        lab.title = nm;
        var lx = lp[0] / W * 100;
        lab.style.left = lx.toFixed(2) + '%';
        lab.style.top = (lp[1] / H * 100).toFixed(2) + '%';
        /* 端点标签不越出包裹层：向左/右可用宽度即到边缘的百分比（375 下 7em > 20% 宽） */
        if (side !== 'middle') lab.style.maxWidth = 'min(7em,' + (side === 'end' ? lx : 100 - lx).toFixed(2) + '%)';
        lab.style.transform = side === 'end' ? 'translate(-100%,-50%)' : side === 'start' ? 'translate(0,-50%)' : lp[1] < cy ? 'translate(-50%,-100%)' : 'translate(-50%,0)';
        wrap.appendChild(lab);
      });
      var face = document.createElementNS(NS, 'polygon');
      face.setAttribute('points', axes.map(function (nm, i) { return pt(i, R * (agg[nm].ok / agg[nm].total)).join(','); }).join(' '));
      face.setAttribute('fill', '#0f766e'); face.setAttribute('fill-opacity', '0.22');
      face.setAttribute('stroke', '#0f766e'); face.setAttribute('stroke-width', '1.5');
      svg.appendChild(face);
      axes.forEach(function (nm, i) {
        var p = pt(i, R * (agg[nm].ok / agg[nm].total));
        var c = document.createElementNS(NS, 'circle');
        c.setAttribute('cx', p[0]); c.setAttribute('cy', p[1]); c.setAttribute('r', '3');
        c.setAttribute('fill', '#0f766e');
        var t = document.createElementNS(NS, 'title');
        t.textContent = nm + ' ' + agg[nm].ok + '/' + agg[nm].total + ' · ' + Math.round(agg[nm].ok / agg[nm].total * 100) + '%';
        c.appendChild(t);
        svg.appendChild(c);
      });
      box.innerHTML = '';
      wrap.insertBefore(svg, wrap.firstChild);
      box.appendChild(wrap);
      box.hidden = false;
      radarCtx = { svg: svg, axes: axes, pt: pt, R: R, box: box, NS: NS };
    })();
    /* 考点累计口径：exam+subject 卷按 /api/kpmap × tiku-done × tiku-wrong 补「累计 x/y」+ 达阈值标「薄弱考点」（阈值与首页/my/ 一致，样本为该科目全部 done 而非首页/my/ 的最近 100 条；无 exam/subject 不触发）。
       kpmap 已预取时在建行的同一帧同步套用；未就绪才退回异步补位 */
    function applyKpHistory(d) {
      var bySlug = {};
      Object.keys(kpHeadByName).forEach(function (nm) {
        var mm = /\/kp\/([\w-]+)\/$/.exec(agg[nm].href || '');
        if (mm) bySlug[mm[1]] = nm;
      });
      if (Object.keys(bySlug).length === 0) return;
      var done = {}; store.readList('tiku-done').forEach(function (p) { var s = toSlug(p); if (s) done[s] = 1; });
      var wrong = {}; store.readList('tiku-wrong').forEach(function (p) { var s = toSlug(p); if (s) wrong[s] = 1; });
      (d.kps || []).forEach(function (it) {
        var nm = bySlug[it.slug];
        if (!nm || !kpHeadByName[nm]) return;
        var dn = 0; var ok = 0; var wn = 0;
        (it.q || []).forEach(function (s) { if (wrong[s]) wn++; if (done[s]) { dn++; if (!wrong[s]) ok++; } });
        /* 考点页「我的进度」卡首帧：同 initKpPageCard 口径写回三元，首访即知薄弱（作答处只写二元） */
        if (dn > 0) writeKpCard(agg[nm].href, [1, wn > 0 ? 1 : 0, dn >= WEAK_MIN_DONE && ok / dn < WEAK_ACC ? 1 : 0]);
        if (dn <= agg[nm].total) return;
        var head = kpHeadByName[nm].head;
        var right = head.querySelector('.ml-auto') || head;
        var cum = el('span', 'text-[12px] text-muted tabular-nums', '累计 ' + ok + '/' + dn + ' · ' + Math.round(ok / dn * 100) + '%');
        right.insertBefore(cum, right.firstChild ? right.firstChild.nextSibling : null);
        if (dn >= WEAK_MIN_DONE && ok / dn < WEAK_ACC) {
          head.insertBefore(el('span', 'shrink-0 rounded-full bg-rose-100 px-1.5 py-0.5 text-[11px] font-medium text-rose-700', '薄弱考点'), right);
        }
      });
    }
    function injectKpHistory() {
      if (!kpParams()) return;
      if (kpmapData) { applyKpHistory(kpmapData); return; }
      prefetchKpmap().then(function (d) { if (d) applyKpHistory(d); });
    }
    /* 整卷全站题目统计单一拉取：按 20 一批（API 上限）memo，考点参照与复盘卡共用同一批响应；
       结果精简后存进会话 ws.qsd，刷新/恢复时各消费方同步拿到、随报告同帧渲染（不再晚插位移） */
    var qstatsAllP = null;
    function qstatsAll() {
      if (qstatsAllP) return qstatsAllP;
      var slugs = qs.map(function (q) { return q.slug; });
      var reqs = [];
      for (var i = 0; i < slugs.length; i += 20) {
        reqs.push(fetch('/api/qstats?slugs=' + encodeURIComponent(slugs.slice(i, i + 20).join(',')))
          .then(function (r) { return r.json(); })
          .then(function (d) { return d.items || []; })
          .catch(function () { return []; }));
      }
      qstatsAllP = Promise.all(reqs).then(function (parts) {
        var items = parts.reduce(function (acc, part) { return acc.concat(part); }, []);
        ws.qsd = items.map(function (it) { return { slug: it.slug, attempts: it.attempts || 0, correct: it.correct || 0, avgms: it.avgms || 0 }; });
        saveSession();
        return ws.qsd;
      });
      return qstatsAllP;
    }
    function withQstats(fn) {
      if (Array.isArray(ws.qsd)) { fn(ws.qsd); return; }
      qstatsAll().then(fn).catch(function () { /* noop */ });
    }
    /* 考点全站参照：本卷同题集按考点聚合 /api/qstats，attempts≥5 的题 ≥2 道才显示 */
    var kpHeadByName = {};
    function injectKpQstats() {
      var kpsBySlug = {};
      qs.forEach(function (q) {
        var names = (q.kps || []).map(function (k) { return k.name; });
        if (names.length === 0) names = ['未归类'];
        kpsBySlug[q.slug] = names;
      });
      withQstats(function (items) {
        var g = {}; var tsum = 0; var tn = 0;
        items.forEach(function (it) {
          if ((it.attempts || 0) < 5) return;
          if (it.avgms > 0) { tsum += it.avgms; tn += 1; }
          (kpsBySlug[it.slug] || []).forEach(function (nm) {
            if (!g[nm]) g[nm] = { att: 0, cor: 0, n: 0 };
            g[nm].att += it.attempts; g[nm].cor += it.correct; g[nm].n += 1;
          });
        });
        /* 全站平均每题用时参照：本卷有均时统计的题 ≥5 道才显示；统计行下独占一行（趋势行之后） */
        if (tn >= 5 && !$('ws-site-avg')) {
          var siteAvg = Math.round(tsum / tn / 1000);
          var av = $('ws-avg');
          var avRow = av && av.parentNode ? av.parentNode.parentNode : null;
          if (siteAvg > 0 && avRow && avRow.parentNode) {
            var ln = el('p', 'mt-1 text-center text-[11px] text-muted tabular-nums', '全站平均每题 ' + siteAvg + ' 秒');
            ln.id = 'ws-site-avg';
            if (avgSec > 0 && avgSec <= siteAvg * 0.8) ln.appendChild(el('span', 'ml-1 rounded-full bg-emerald-100 px-1.5 py-0.5 text-[11px] font-medium text-emerald-700', '更快'));
            else if (avgSec >= siteAvg * 1.2) ln.appendChild(el('span', 'ml-1 rounded-full bg-amber-100 px-1.5 py-0.5 text-[11px] font-medium text-amber-700', '偏慢'));
            var after = $('ws-prev-acc') || $('ws-split') || avRow;
            after.parentNode.insertBefore(ln, after.nextSibling);
          }
        }
        Object.keys(kpHeadByName).forEach(function (nm) {
          var s = g[nm];
          if (!s || s.n < 2 || s.att === 0) return;
          var gp = Math.round(s.cor / s.att * 100);
          kpHeadByName[nm].head.appendChild(el('span', 'shrink-0 text-[12px] text-muted tabular-nums', '全站 ' + gp + '%'));
          var diff = kpHeadByName[nm].pct - gp;
          if (diff >= 10 || diff <= -10) {
            kpHeadByName[nm].head.appendChild(el('span', 'shrink-0 rounded-full px-1.5 py-0.5 text-[11px] font-medium ' +
              (diff >= 10 ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'), diff >= 10 ? '领先' : '落后'));
          }
        });
        /* 雷达叠加全站参照标记：逐轴独立 fail-closed，无统计的轴不画 */
        if (radarCtx) {
          var marks = 0;
          radarCtx.axes.forEach(function (nm, i) {
            var s = g[nm];
            if (!s || s.n < 2 || s.att === 0) return;
            var gp = Math.round(s.cor / s.att * 100);
            var p = radarCtx.pt(i, radarCtx.R * gp / 100);
            var c = document.createElementNS(radarCtx.NS, 'circle');
            c.setAttribute('cx', p[0]); c.setAttribute('cy', p[1]); c.setAttribute('r', '3.5');
            c.setAttribute('fill', 'none'); c.setAttribute('stroke', '#d97706'); c.setAttribute('stroke-width', '1.5');
            var tt = document.createElementNS(radarCtx.NS, 'title');
            tt.textContent = '全站 ' + nm + ' ' + gp + '%';
            c.appendChild(tt);
            radarCtx.svg.appendChild(c);
            marks++;
          });
          if (marks > 0) {
            var lg = el('div', 'mt-1 flex items-center justify-center gap-3 text-[11px] text-muted');
            var me = el('span', 'inline-flex items-center gap-1');
            var dot = el('span', 'inline-block h-2 w-2 rounded-full'); dot.style.background = '#0f766e';
            me.appendChild(dot); me.appendChild(el('span', '', '我的正确率'));
            var site = el('span', 'inline-flex items-center gap-1');
            var ring = el('span', 'inline-block h-2 w-2 rounded-full'); ring.style.border = '1.5px solid #d97706';
            site.appendChild(ring); site.appendChild(el('span', '', '全站参照'));
            lg.appendChild(me); lg.appendChild(site);
            radarCtx.box.appendChild(lg);
          }
        }
      });
    }
    if (order.length > 0) {
      $('ws-kp-empty').style.display = 'none';
      var byAcc = function (a, b) { return agg[a].ok / agg[a].total - agg[b].ok / agg[b].total; };
      var tops = order.filter(function (nm) { return !kpParentOf[nm]; }).sort(byAcc);
      order = [];
      tops.forEach(function (p) {
        order.push(p);
        Object.keys(kpParentOf).filter(function (c) { return kpParentOf[c] === p; }).sort(byAcc).forEach(function (c) { order.push(c); });
      });
      var list = $('ws-kp-list');
      /* 智能练习侧重的薄弱考点（meta.focus：kp slug）：行内徽标 + 列表顶部一句说明 */
      var focusSet = {};
      (Array.isArray(meta.focus) ? meta.focus : []).forEach(function (s) { focusSet[s] = 1; });
      var isFocus = function (nm) {
        var mm = /\/kp\/([\w-]+)\/$/.exec(agg[nm].href || '');
        return Boolean(mm && focusSet[mm[1]]);
      };
      var focusNames = order.filter(isFocus);
      var oldNote = document.getElementById('ws-kp-focus');
      if (oldNote) oldNote.remove();
      if (focusNames.length > 0) {
        var lead = meta.focusKind === 'miss' ? '本卷侧重你近期错过的考点：' : '本卷按你的薄弱考点加权选题：';
        var note = el('p', 'mb-3 rounded-lg bg-amber-50 px-3 py-2 text-[13px] text-amber-900', lead + focusNames.join('、') + '（标「侧重」行）');
        note.id = 'ws-kp-focus';
        list.parentNode.insertBefore(note, list);
      }
      order.forEach(function (nm) {
        var p2 = Math.round(agg[nm].ok / agg[nm].total * 100);
        var par = kpParentOf[nm] || '';
        var row = el('div', par ? 'pl-3' : '');
        var head = el('div', 'flex flex-wrap items-baseline justify-between gap-x-2 gap-y-0.5 text-[13px]');
        var nmEl;
        if (agg[nm].href) {
          nmEl = el('a', 'min-w-0 truncate py-2.5 -my-2.5 leading-5 text-slate-700 hover:text-brand-700 hover:underline', par ? '' : nm);
          nmEl.href = agg[nm].href;
        } else {
          nmEl = el('span', 'min-w-0 truncate leading-5 text-slate-700', par ? '' : nm);
        }
        if (par) {
          nmEl.appendChild(el('span', 'sr-only', par + '·'));
          nmEl.appendChild(el('span', 'text-muted', '└ '));
          nmEl.appendChild(document.createTextNode(nm.slice(par.length + 1)));
        }
        head.appendChild(nmEl);
        if (isFocus(nm)) head.appendChild(el('span', 'shrink-0 rounded bg-amber-100 px-1.5 py-0.5 text-[11px] font-medium text-amber-800', '侧重'));
        var right = el('span', 'ml-auto flex shrink-0 items-baseline gap-2');
        right.appendChild(el('span', 'text-muted tabular-nums', agg[nm].ok + '/' + agg[nm].total + ' · ' + p2 + '%' + unSuffix(agg[nm].un)));
        if (agg[nm].wrong.length > 0) {
          var drill = el('a', 'inline-flex min-h-10 items-center font-medium text-brand-700 hover:underline', '重刷 →');
          drill.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(agg[nm].wrong.join(','));
          right.appendChild(drill);
        }
        head.appendChild(right);
        kpHeadByName[nm] = { head: head, pct: p2 };
        var track = el('div', 'mt-1 h-2 overflow-hidden rounded-full bg-slate-100');
        var bar = el('div', 'h-full rounded-full ' + (p2 >= 80 ? 'bg-emerald-500' : p2 >= 50 ? 'bg-amber-400' : 'bg-red-400'));
        bar.style.width = p2 + '%';
        track.appendChild(bar);
        row.appendChild(head); row.appendChild(track); list.appendChild(row);
      });
      injectKpQstats();
      injectKpHistory();
    }
    /* 答题卡总览：整卷对错网格，点击进入回看并定位该题 */
    (function () {
      var rg = $('ws-report-sheet'); if (!rg) return;
      rg.innerHTML = '';
      var oldLg = document.getElementById('ws-report-legend');
      if (oldLg) oldLg.remove();
      if (unN > 0 && rg.parentNode) {
        var lg = el('div', 'mb-3 flex flex-wrap items-center gap-3 text-[12px] text-muted');
        lg.id = 'ws-report-legend';
        [['bg-emerald-700', '正确'], ['bg-red-600', '错误'], ['border border-line bg-white', '未答']].forEach(function (it) {
          var s = el('span', 'inline-flex items-center gap-1');
          s.appendChild(el('span', 'inline-block size-3 rounded ' + it[0]));
          s.appendChild(el('span', '', it[1]));
          lg.appendChild(s);
        });
        rg.parentNode.insertBefore(lg, rg);
      }
      /* 键盘：整卡只占 Tab 序列一位（roving tabindex），方向键按当前列数在题号间移动，Home/End 首末 */
      if (!rg.dataset.rove) {
        rg.dataset.rove = '1';
        rg.addEventListener('keydown', function (e) {
          var cells = Array.prototype.slice.call(rg.querySelectorAll('button'));
          var idx = cells.indexOf(document.activeElement);
          if (idx < 0) return;
          var cols = getComputedStyle(rg).gridTemplateColumns.split(' ').length || 1;
          var to;
          if (e.key === 'ArrowRight') to = idx + 1;
          else if (e.key === 'ArrowLeft') to = idx - 1;
          else if (e.key === 'ArrowDown') to = Math.min(cells.length - 1, idx + cols);
          else if (e.key === 'ArrowUp') to = Math.max(0, idx - cols);
          else if (e.key === 'Home') to = 0;
          else if (e.key === 'End') to = cells.length - 1;
          else return;
          if (to < 0 || to >= cells.length || to === idx) { e.preventDefault(); return; }
          e.preventDefault();
          cells[idx].tabIndex = -1; cells[to].tabIndex = 0; cells[to].focus();
        });
      }
      qs.forEach(function (q, i) {
        sheetGroupLabel(rg, q, i);
        var okQ = ws.ans[i].ok === true;
        var unQ = !okQ && isUn(i);
        var b = el('button', '', String(i + 1));
        b.type = 'button';
        b.tabIndex = i === 0 ? 0 : -1;
        b.className = 'relative grid h-10 place-items-center rounded-lg text-sm font-medium tabular-nums ' +
          (okQ ? 'bg-emerald-700 text-white' : unQ ? 'border border-line bg-white text-slate-600' : 'bg-red-600 text-white');
        if (ws.mk[i] === 1) b.appendChild(el('span', 'absolute -right-0.5 -top-0.5 size-2 rounded-full bg-amber-400 ring-2 ring-white'));
        b.setAttribute('aria-label', '第 ' + (i + 1) + ' 题' + (okQ ? '，已答对' : unQ ? '，未作答' : '，答错') + (ws.mk[i] === 1 ? '，已标记' : '') + '，点击回看解析');
        b.addEventListener('click', function () {
          ws.i = i; saveSession();
          enterReview();
        });
        rg.appendChild(b);
      });
    })();
    /* 复盘列表 = 错题 ∪ 未答 ∪ 标记题（按题序），徽标区分；错因/举一反三只对真答错渲染 */
    var reviewQ = [];
    qs.forEach(function (q, i) {
      var isWrong = ws.ans[i].ok !== true;
      var isMarked = ws.mk[i] === 1;
      if (isWrong || isMarked) reviewQ.push({ q: q, i: i, wrong: isWrong, un: isWrong && isUn(i), marked: isMarked, sec: ws.qt[i] > 0 ? Math.round(ws.qt[i] / 1000) : 0 });
    });
    if (reviewQ.length > 0) {
      $('ws-wrong-empty').style.display = 'none';
      var wl = $('ws-wrong-list');
      var qstatEls = {};
      reviewQ.forEach(function (it) {
        var q = it.q;
        /* 每题一个 wrap 进 grid：题卡 + 错因行 + 相似题行在 ≥md 双栏下不再各占一格 */
        var wrap = el('div', '');
        /* 分类标记供筛选芯片：u=未答 w=答错 m=标记（可叠加） */
        wrap.setAttribute('data-rv', (it.un ? 'u' : it.wrong ? 'w' : '') + (it.marked ? 'm' : ''));
        var a = el('a', 'block rounded-xl border border-line bg-white p-4 shadow-sm transition hover:border-brand-600/40 hover:shadow-md');
        a.href = '/q/' + q.slug + '/';
        /* 主点击与答题卡网格同口径：站内回看定位本题（我的作答 + 解析，不写记录）；修饰键/中键仍到单题页 */
        a.addEventListener('click', function (e) {
          if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          ws.i = it.i; saveSession();
          enterReview();
          window.scrollTo({ top: 0 });
        });
        /* 图形题题干是模板文案（只差题号），题干右侧直出题图缩略图才能一眼分辨；数据与操作台同源（q.fig 已在会话内，零请求），列表里不重复播报长题图描述 */
        var head = el('div', 'flex items-start gap-3');
        head.appendChild(el('p', 'min-w-0 flex-1 line-clamp-2 text-[15px] leading-relaxed text-ink', q.stem));
        if (safeSvg(q.fig)) {
          var th = el('div', 'qz-fig w-24 shrink-0 rounded-lg border border-line bg-white p-1.5');
          th.innerHTML = q.fig;
          th.setAttribute('aria-hidden', 'true');
          head.appendChild(th);
        }
        a.appendChild(head);
        var m = el('p', 'mt-2 flex flex-wrap items-center gap-2 text-[13px] text-slate-600');
        if (it.un) m.appendChild(el('span', 'rounded-full bg-slate-100 px-2 py-0.5 font-medium text-slate-600', '未答'));
        else if (it.wrong) {
          m.appendChild(el('span', 'rounded-full bg-red-100 px-2 py-0.5 font-medium text-red-700', '答错'));
          /* 我选什么 / 正确答案直出（会话内数据，不必点「回看解析」） */
          var myPick = (ws.ans[it.i].picked || []).slice().sort().join('');
          if (myPick && myPick !== q.answer.split('').sort().join('')) m.appendChild(el('span', 'tabular-nums', '选 ' + myPick + ' · 答案 ' + q.answer));
        }
        else m.appendChild(el('span', 'rounded-full bg-emerald-100 px-2 py-0.5 font-medium text-emerald-700', '已答对'));
        if (it.marked) m.appendChild(el('span', 'rounded-full bg-amber-100 px-2 py-0.5 font-medium text-amber-700', '已标记'));
        m.appendChild(el('span', 'rounded-full bg-slate-100 px-2 py-0.5', QTYPE[q.qtype] || q.qtype));
        m.appendChild(el('span', '', '难度 ' + stars(q.difficulty)));
        if (it.sec > 0) {
          m.appendChild(el('span', 'tabular-nums', '用时 ' + it.sec + ' 秒'));
          if (it.sec >= 30 && it.sec > 2 * avgSec) m.appendChild(el('span', 'rounded-full bg-amber-100 px-2 py-0.5 font-medium text-amber-700', '偏慢'));
        }
        m.appendChild(el('span', 'js-rv ml-auto font-medium text-brand-700', '回看解析 →'));
        a.appendChild(m); wrap.appendChild(a);
        if (!qstatEls[q.slug]) qstatEls[q.slug] = m;
        if (it.wrong && !it.un) {
          a.classList.remove('rounded-xl'); a.classList.add('rounded-t-xl');
          var rr = reasonRow(q.slug);
          wrap.appendChild(rr);
          /* 举一反三：同考点抽 3 题（排除本题），与解析区入口同 URL 契约，无考点不显示 */
          var skm = /^\/kaoshi\/([\w-]+)\/([\w-]+)\/kp\/([\w-]+)\/$/.exec((q.kps && q.kps[0] && q.kps[0].href) || '');
          if (skm) {
            rr.classList.remove('rounded-b-xl');
            var sr = el('div', 'js-sim-row rounded-b-xl border border-t-0 border-line bg-white px-4 py-2 text-[12px]');
            var sa = el('a', 'tap-y inline-flex items-center font-medium text-brand-700 hover:underline', '练 3 道相似题（同考点）→');
            sa.href = '/practice/?mode=custom&exam=' + skm[1] + '&subject=' + skm[2] + '&kp=' + skm[3] + '&n=3#x=' + encodeURIComponent(q.slug);
            sr.appendChild(sa);
            wrap.appendChild(sr);
          }
        }
        wl.appendChild(wrap);
      });
      /* 分类筛选芯片：全部 / 答错 / 未答 / 标记，只列非零类；仅一类时不显示（与无芯片时行为一致）；筛选态随会话持久化 */
      var rvCount = { w: 0, u: 0, m: 0 };
      reviewQ.forEach(function (it) {
        if (it.un) rvCount.u++; else if (it.wrong) rvCount.w++;
        if (it.marked) rvCount.m++;
      });
      var rvKinds = [['w', '答错'], ['u', '未答'], ['m', '标记']].filter(function (k) { return rvCount[k[0]] > 0; });
      var rvOldF = $('ws-rv-filter'); if (rvOldF) rvOldF.remove();
      if (rvKinds.length >= 2) {
        var rvF = el('div', 'mb-3 flex min-h-10 flex-wrap items-center gap-1.5 text-[13px]');
        rvF.id = 'ws-rv-filter';
        rvF.setAttribute('role', 'group');
        rvF.setAttribute('aria-label', '复盘列表筛选');
        var rvLive = el('span', 'sr-only');
        rvLive.setAttribute('role', 'status');
        var rvBtns = [['all', '全部', reviewQ.length]].concat(rvKinds.map(function (k) { return [k[0], k[1], rvCount[k[0]]]; }));
        var rvCur = ws.rf && rvBtns.some(function (b) { return b[0] === ws.rf; }) ? ws.rf : 'all';
        function applyRvFilter(f, announce) {
          rvCur = f; ws.rf = f === 'all' ? '' : f; saveSession();
          var shown = 0;
          Array.prototype.forEach.call(wl.children, function (w) {
            var hide = f !== 'all' && (w.getAttribute('data-rv') || '').indexOf(f) < 0;
            w.hidden = hide; if (!hide) shown++;
          });
          Array.prototype.forEach.call(rvF.querySelectorAll('button'), function (b) {
            var on = b.getAttribute('data-rv-f') === f;
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            b.className = on
              ? 'tap-y rounded-full bg-brand-700 px-3 py-1 font-medium text-white'
              : 'tap-y rounded-full border border-line bg-slate-50 px-3 py-1 text-slate-600 hover:bg-brand-50';
          });
          if (announce) { rvLive.textContent = ''; rvLive.textContent = '显示' + rvBtns.filter(function (b) { return b[0] === f; })[0][1] + ' ' + shown + ' 题'; }
        }
        rvBtns.forEach(function (b) {
          var btn = el('button', '', b[1] + ' ' + b[2]);
          btn.type = 'button';
          btn.setAttribute('data-rv-f', b[0]);
          btn.addEventListener('click', function () { applyRvFilter(b[0], true); });
          rvF.appendChild(btn);
        });
        rvF.appendChild(rvLive);
        wl.parentNode.insertBefore(rvF, wl);
        applyRvFilter(rvCur, false);
      } else if (ws.rf) { ws.rf = ''; saveSession(); }
      /* 全站正确率社会参照：与考点参照共用 qstatsAll() 整卷一次拉取；attempts<5 不显示 */
      withQstats(function (items) {
        items.forEach(function (it) {
          var m = qstatEls[it.slug];
          if (!m || it.attempts < 5) return;
          var pct = Math.round(it.correct / it.attempts * 100);
          m.appendChild(el('span', 'rounded-full bg-slate-100 px-2 py-0.5 tabular-nums', '全站 ' + pct + '% 做对'));
          if (pct < 50) m.appendChild(el('span', 'rounded-full bg-red-100 px-2 py-0.5 font-medium text-red-700', '易错'));
          if (it.avgms) m.appendChild(el('span', 'rounded-full bg-slate-100 px-2 py-0.5 tabular-nums', '全站均时 ' + Math.round(it.avgms / 1000) + ' 秒'));
          var rv = m.querySelector('.js-rv'); if (rv) m.appendChild(rv);
        });
      });
    }
    /* 报告主入口从第 1 题起（R26 §4）；答题卡格 / 复盘卡定位到具体题（R501） */
    $('ws-review').addEventListener('click', function () { ws.i = 0; saveSession(); enterReview(); window.scrollTo({ top: 0 }); });
    /* 复习卷（review=1）闭环：交卷后重算剩余到期错题（契约与 app.js wrongDue 一致），续批或清零反馈 */
    if (/[?&]review=1(&|$)/.test(location.search)) {
      var rvOld = document.getElementById('ws-review-loop');
      if (rvOld) rvOld.parentNode.removeChild(rvOld);
      var rvWrong = store.readList('tiku-wrong');
      var rvWt = store.read('tiku-wrongt', '{}');
      var rvWk = store.read('tiku-wrongk', '{}');
      var rvDue = rvWrong.filter(function (p) { return reviewDue(rvWt[p], rvWk[p]); });
      rvDue.sort(function (a, b) { return (rvWt[a] || 0) - (rvWt[b] || 0); });
      var rvBox = el('div', 'flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-300 bg-amber-50 p-3.5');
      rvBox.id = 'ws-review-loop';
      if (rvDue.length > 0) {
        rvBox.appendChild(el('p', 'text-sm text-amber-800', '今日还剩 ' + rvDue.length + ' 题待复习'));
        var rvGo = el('a', 'inline-flex h-10 items-center rounded-lg bg-amber-700 px-3.5 text-sm font-medium text-white hover:bg-amber-800', '继续复习 →');
        var rvSlugs = rvDue.map(function (p) { return (p.match(/^\/q\/([\w-]+)\/$/) || [])[1]; }).filter(Boolean).slice(0, 20);
        rvGo.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(rvSlugs.join(',')) + '&review=1';
        rvBox.appendChild(rvGo);
      } else if (wrongQ.length - unN > 0) {
        /* 答错的题时间戳已重置、1 天后再到期：今日无剩余不等于「清零」 */
        rvBox.appendChild(el('p', 'text-sm text-amber-800', '今日到期错题已复习完 · 本卷 ' + (wrongQ.length - unN) + ' 道仍答错，明天从第 1 轮重新回炉'));
      } else {
        rvBox.appendChild(el('p', 'text-sm text-amber-800', '今日复习清零 🎉 答对推进复习轮次，三轮答对自动出师移出'));
      }
      var rvRow = $('ws-review').parentNode;
      rvRow.parentNode.insertBefore(rvBox, rvRow);
    }
    if (wrongQ.length > 0) {
      var redo = $('ws-redo');
      redo.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(wrongQ.map(function (q) { return q.slug; }).join(','));
      redo.textContent = unN > 0 ? (unN === wrongQ.length ? '重做本卷未答题 →' : '重刷本卷错题与未答 →') : '重刷本卷错题 →';
      redo.hidden = false;
      /* 错题闭环告知：非复习卷提示错题已入错题本与 1/3/7 天间隔复习安排 */
      /* 未答题不落错题本（交卷不 recordAnswer），提示只数真答错 */
      if (!/[?&]review=1(&|$)/.test(location.search) && wrongQ.length - unN > 0) {
        var wbOld = document.getElementById('ws-wrongbook-note');
        if (wbOld) wbOld.parentNode.removeChild(wbOld);
        var wbNote = el('p', 'mt-3 w-full text-[13px] text-muted');
        wbNote.id = 'ws-wrongbook-note';
        wbNote.appendChild(document.createTextNode('本卷 ' + (wrongQ.length - unN) + ' 道错题已自动加入错题本，将按 1/3/7 天间隔安排复习 '));
        var wbA = el('a', 'tap-y inline-flex items-center font-medium text-brand-700 hover:underline', '去错题本 →');
        wbA.href = '/my/#wrong-h';
        var wbS1 = el('span', 'whitespace-nowrap', '· ');
        wbS1.appendChild(wbA);
        wbNote.appendChild(wbS1);
        wbNote.appendChild(document.createTextNode(' '));
        var wbP = el('a', 'tap-y inline-flex items-center font-medium text-brand-700 hover:underline', '打印错题（纸质巩固）→');
        wbP.id = 'ws-print-wrong';
        wbP.href = '/print/?slugs=' + encodeURIComponent(wrongQ.slice(0, 150).map(function (q) { return q.slug; }).join(','));
        var wbS2 = el('span', 'whitespace-nowrap', '· ');
        wbS2.appendChild(wbP);
        wbNote.appendChild(wbS2);
        redo.parentNode.appendChild(wbNote);
      }
    }
    var again = $('ws-again');
    var fixedSmart = !meta.nextPaper && !meta.againHref && meta.scoreKey ? smartHrefFor(qs, wrongQ, meta.mode === 'mockline') : '';
    if (meta.nextPaper) { again.href = meta.nextPaper; again.textContent = '连刷下一页 →'; }
    else if (meta.againHref) { again.href = meta.againHref; again.textContent = '再来一卷智能练习 →'; }
    else if (fixedSmart) { again.href = fixedSmart; again.textContent = '智能练习巩固 →'; }
    else {
      again.href = location.pathname + location.search + HXS;
      again.addEventListener('click', function (e) {
        try { sessionStorage.removeItem(SKEY); } catch (_) { /* noop */ }
        /* 同 URL 含 fragment 时点链接只是片段导航（不重载、不触发 hashchange） */
        if (HXS) { e.preventDefault(); location.reload(); }
      });
      /* scoreKey 卷（每日一练/固定模考）是确定性题集，同 URL 再来只会拿到原卷 */
      again.textContent = meta.mode === 'slugs' || meta.scoreKey ? '重刷本卷 →' : '再来一卷 →';
    }
    /* AI 智能点评：点击才生成（消耗与答疑共享的每日额度），结果随会话持久化回显 */
    (function () {
      var sec = $('ws-ai-sec'), btn = $('ws-ai-btn'), out = $('ws-ai-out'), aMsg = $('ws-ai-msg');
      if (!sec || !btn || !out || !aMsg) return;
      function render(text) {
        out.textContent = '';
        String(text || '').split(/\n+/).forEach(function (p) {
          p = p.trim();
          if (p) out.appendChild(el('p', '', p));
        });
        out.hidden = false;
        btn.hidden = true;
      }
      if (ws.air) { render(ws.air); return; }
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        btn.disabled = true;
        aMsg.hidden = false; aMsg.className = 'mt-2 text-[13px] text-muted'; aMsg.textContent = 'AI 点评生成中…';
        var kpArr = order.slice();
        kpArr.sort(function (a, b) { return agg[b].total - agg[a].total; });
        var kpsBody = kpArr.slice(0, 8).map(function (nm) { return { name: nm.slice(0, 40), ok: agg[nm].ok, n: agg[nm].total }; });
        fetch('/api/ai-review', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: aiToken(), title: meta.title, n: qs.length, ok: okN, un: unN, used: used, kps: kpsBody, focus: (focusNames || []).slice(0, 3).map(function (nm) { return nm.slice(0, 40); }) })
        }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); }).then(function (res) {
          if (!res.ok) throw new Error(res.d && res.d.error ? res.d.error : '请求失败');
          ws.air = String(res.d.answer || ''); saveSession();
          /* 点评历史 tiku-air：{t:卷名,n:题数,ok:答对,a:点评,ts}，新在前 cap 20，随云同步 */
          try {
            var arl = JSON.parse(localStorage.getItem('tiku-air') || '[]');
            if (!Array.isArray(arl)) arl = [];
            arl.unshift({ t: String(meta.title || '').slice(0, 60), n: qs.length, ok: okN, a: ws.air.slice(0, 600), ts: Date.now() });
            localStorage.setItem('tiku-air', JSON.stringify(arl.slice(0, 20)));
          } catch (_) { /* noop */ }
          render(ws.air);
          aMsg.textContent = (typeof res.d.left === 'number' ? '今日剩余 ' + res.d.left + ' 次 · ' : '') + 'AI 点评仅供参考';
        }).catch(function (e) {
          aMsg.className = 'mt-2 text-[13px] text-red-600';
          aMsg.textContent = (e && e.message) ? e.message : 'AI 点评暂不可用，请稍后重试';
          btn.disabled = false;
        });
      });
    })();
    initShareCard(pct, okN, used, ansN > 0 ? avgSec : 0);
    if (!revealWait) revealReport();
  }

  /* 成绩分享卡：纯客户端 Canvas 生成 PNG，仅含个人成绩数字与站点信息，不上传任何数据 */
  function initShareCard(pct, okN, used, avgSec) {
    var btn = $('ws-share');
    var msg = $('ws-share-msg');
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    function say(text) { msg.textContent = text; msg.classList.remove('hidden'); }
    /* 二维码库懒加载：报告阶段才取，失败时分享卡降级为无码版 */
    if (!window.qrcode && !document.getElementById('ws-qrlib')) {
      var s = document.createElement('script');
      s.id = 'ws-qrlib'; s.src = '/qrcode.js?v=1'; s.async = true;
      document.head.appendChild(s);
    }
    function drawQR(ctx, cx, top) {
      if (!window.qrcode) return false;
      try {
        var q = window.qrcode(0, 'M');
        q.addData('https://tiku.zalize.com/'); q.make();
        var n = q.getModuleCount();
        var size = 150; var cell = size / n;
        var x0 = cx - size / 2;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(x0 - 12, top - 12, size + 24, size + 24);
        ctx.fillStyle = '#0f172a';
        for (var r = 0; r < n; r++) {
          for (var c = 0; c < n; c++) {
            if (q.isDark(r, c)) ctx.fillRect(x0 + c * cell, top + r * cell, Math.ceil(cell), Math.ceil(cell));
          }
        }
        return true;
      } catch (_) { return false; }
    }
    function drawCard() {
      var W = 750; var H = 1140;
      var cv = document.createElement('canvas');
      cv.width = W; cv.height = H;
      var ctx = cv.getContext('2d');
      ctx.fillStyle = '#f0fdfa'; ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = '#0d9488'; ctx.fillRect(0, 0, W, 148);
      ctx.fillStyle = '#ffffff'; ctx.textAlign = 'left';
      ctx.font = 'bold 44px system-ui, sans-serif';
      ctx.fillText('刷题营', 48, 78);
      ctx.font = '26px system-ui, sans-serif'; ctx.globalAlpha = 0.85;
      ctx.fillText('练习报告 · tiku.zalize.com', 48, 118);
      ctx.globalAlpha = 1;
      /* 每日一练打卡角标（头部右侧，与排位行独立） */
      if (meta.mode === 'daily') {
        var stk = dailyStreak();
        if (stk > 0) {
          ctx.textAlign = 'right'; ctx.font = 'bold 28px system-ui, sans-serif';
          ctx.fillText('🔥 连续打卡 ' + stk + ' 天', W - 48, 118);
          ctx.textAlign = 'left';
        }
      }
      ctx.fillStyle = '#334155'; ctx.font = '30px system-ui, sans-serif';
      /* 标题按像素宽截断并补省略号（左右各 48 内边距） */
      var title = meta.title || '';
      var maxW = W - 96;
      if (ctx.measureText(title).width > maxW) {
        while (title.length > 1 && ctx.measureText(title + '…').width > maxW) title = title.slice(0, -1);
        title = title.replace(/[\s·（(［\[「《]+$/, '') + '…';
      }
      ctx.fillText(title, 48, 220);
      /* 得分环 */
      var cx = W / 2; var cy = 460; var r = 170;
      ctx.lineWidth = 26; ctx.lineCap = 'round';
      ctx.strokeStyle = '#e2e8f0';
      ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.stroke();
      ctx.strokeStyle = '#0d9488';
      ctx.beginPath(); ctx.arc(cx, cy, r, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * pct / 100); ctx.stroke();
      ctx.fillStyle = '#0f172a'; ctx.textAlign = 'center';
      ctx.font = 'bold 110px system-ui, sans-serif';
      ctx.fillText(String(pct), cx, cy + 20);
      ctx.font = '30px system-ui, sans-serif'; ctx.fillStyle = '#64748b';
      ctx.fillText('得分', cx, cy + 76);
      /* 名次/击败百分比（有同场成绩数据时）；n≤1 与报告 paintBeat 同口径写首位交卷，不出「第 1 名 · 击败了 0%」 */
      if (ws.psr && typeof ws.psr.beat === 'number') {
        var sk = meta.scoreKey || '';
        var scope = sk.indexOf('daily:') === 0 ? '今日' : sk.indexOf('weekly:') === 0 ? '本周' : '本卷';
        var rankTxt = typeof ws.psr.rank === 'number' ? scope + '第 ' + ws.psr.rank + ' 名 · ' : '';
        ctx.fillStyle = '#0d9488'; ctx.font = 'bold 32px system-ui, sans-serif';
        ctx.fillText(Number(ws.psr.n) <= 1 ? scope + '首位交卷 · 暂无同卷对比' : rankTxt + '击败了 ' + ws.psr.beat + '% 的刷题人', cx, 692);
      }
      /* 三项数据 */
      var items = [
        [okN + '/' + qs.length, '答对/总题'],
        [Math.floor(used / 60) + '分' + (used % 60) + '秒', '用时'],
        [avgSec > 0 ? avgSec + ' 秒' : '—', '平均每题']
      ];
      items.forEach(function (it, i) {
        var x = W / 6 + i * (W / 3);
        ctx.fillStyle = '#0f172a'; ctx.font = 'bold 42px system-ui, sans-serif';
        ctx.fillText(it[0], x, 760);
        ctx.fillStyle = '#64748b'; ctx.font = '26px system-ui, sans-serif';
        ctx.fillText(it[1], x, 806);
      });
      /* 扫码直达二维码（库未就绪时降级为无码版，高度不变） */
      var hasQR = drawQR(ctx, cx, 862);
      if (hasQR) {
        ctx.fillStyle = '#64748b'; ctx.font = '24px system-ui, sans-serif';
        ctx.fillText('扫码一起来刷题', cx, 1058);
      }
      var d = new Date();
      ctx.fillStyle = '#94a3b8'; ctx.font = '26px system-ui, sans-serif';
      ctx.fillText(d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate() + ' · 一起来刷题 tiku.zalize.com', cx, 1104);
      return cv;
    }
    btn.addEventListener('click', function () {
      drawCard().toBlob(function (blob) {
        if (!blob) { say('生成图片失败，请稍后再试'); return; }
        var file = null;
        try { file = new File([blob], 'tiku-score.png', { type: 'image/png' }); } catch (_) { /* noop */ }
        if (file && navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
          navigator.share({ files: [file], title: '刷题营练习报告' }).catch(function () { /* 用户取消 */ });
          return;
        }
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'tiku-score.png';
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(a.href); }, 5000);
        say('成绩卡已保存为图片（tiku-score.png）');
      }, 'image/png');
    });
  }

  /* ---------- 启动 ---------- */
  /* 开卷预取本卷既有样本（边缘缓存 60s，不含自己）：交卷时排名 pill/分布可同步占位，报告几何不依赖 POST 往返 */
  var psPre = null;
  function prefetchScore() {
    if (!meta.scoreKey || ws.psr || ws.ps) return;
    try {
      fetch('/api/paper-score?key=' + encodeURIComponent(meta.scoreKey))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && typeof d.n === 'number' && Array.isArray(d.buckets) && d.buckets.length === 10) psPre = d; })
        .catch(function () { /* 静默：回退等 POST */ });
    } catch (_) { /* noop */ }
  }
  function boot(data, restored) {
    meta = data.meta; qs = data.questions || [];
    if (qs.length === 0) { $('ws-loading').remove(); $('ws-error').classList.remove('hidden'); return; }
    if (!restored) {
      ws.ans = qs.map(function () { return { picked: [], done: false, ok: null, viewed: false }; });
      if (meta.minutes > 0) ws.end = ws.start + meta.minutes * 60e3;
      /* 每日一练：从第一道未做题开始 */
      if (meta.mode === 'daily') {
        var done = store.readList('tiku-done');
        for (var i = 0; i < qs.length; i++) { if (done.indexOf('/q/' + qs[i].slug + '/') < 0) { ws.i = i; break; } }
      }
      /* 整卷负载入会话：刷新/后退/续练不重新组卷（random/mock 随机卷、跨日的 daily/weekly 都会换题，作答与题面必须同源） */
      saveSession(data);
    }
    var back = document.getElementById('quiz-back');
    if (back) { back.href = meta.backHref; back.setAttribute('aria-label', meta.backLabel); }
    writeLast();
    $('ws-title').textContent = meta.title;
    document.title = meta.title + ' · 做题操作台 | 刷题营';
    prefetchKpmap();
    prefetchScore();
    /* 恢复已交卷会话：等 kpmap 就绪再绘报告，考点「累计」行与首帧同框 */
    if (ws.submitted) {
      kpmapReady(function () { $('ws-loading').remove(); $('ws-nav').classList.remove('hidden'); submitPaper(true); });
      return;
    }
    $('ws-loading').remove();
    root.hidden = false; paintSide();
    $('ws-nav').classList.remove('hidden');
    document.body.classList.add('pb-24');
    renderQ(); paintSheet(); tick();
    /* 暂停仅限非限时模式；限时模考对齐粉笔不可暂停 */
    if (!ws.end) {
      $('ws-pause').classList.remove('hidden');
      if (ws.pa) paintPause();
    }
    paintTimedSettings();
  }
  /* 限时卷设置面板：交卷后判分锁定勾选、背题模式锁定关闭，并说明原因 */
  function paintTimedSettings() {
    var dEl = $('ws-defer'); var bEl = $('ws-browse'); var note = $('ws-timed-note');
    if (!dEl || !bEl) return;
    var t = timed();
    dEl.disabled = t; bEl.disabled = t;
    if (t) { dEl.checked = true; bEl.checked = false; }
    if (note) note.hidden = !t;
  }

  /* ---------- 智能练习 mode=smart：客户端选题后改写为 slugs 卷（个人数据不上传） ----------
     到期错题 ≤floor(n·0.3)（未到期错题不占席：答对不推进轮次，同日多卷会反复出同一批刚答错的题）→ 薄弱考点未做题轮转 ≥ceil(n·0.4)（不够时由「错过考点」——有错题但未达薄弱阈值——的未做题补满，
     新用户 1 题/考点也能在第二卷就偏向刚错的考点）→ 低覆盖考点未做题轮转 → 未做题耗尽才补未到期错题 → 补做对题。
     薄弱口径与 app.js kpPersonalStats 一致：已做 ≥3 且错题本命中率口径正确率 <70%（两处阈值需同步改） */
  var WEAK_MIN_DONE = 3; var WEAK_ACC = 0.7; var REVIEW_GAPS = [86400, 259200, 604800];
  /* 到期判定（契约与 app.js wrongDue 一致）：距最后答错/复习 ≥ 当前轮次间隔，无时间戳视为到期 */
  function reviewDue(t, stg) {
    return typeof t !== 'number' || Math.floor(Date.now() / 1000) - t >= REVIEW_GAPS[Math.max(0, Math.min(2, stg || 0))];
  }
  function toSlug(p) { var mm = /^\/q\/([\w-]+)\/$/.exec(String(p || '')); return mm ? mm[1] : ''; }
  function shuffleArr(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }
  /* 多考点轮转抽题：每轮各考点取 1 题，直到满额或全部抽空（同题挂多考点只取一次） */
  function roundRobin(groups, want, taken) {
    var out = [];
    var pools = groups.map(function (g) { return shuffleArr(g.slice()); });
    var moved = true;
    while (out.length < want && moved) {
      moved = false;
      for (var i = 0; i < pools.length && out.length < want; i++) {
        while (pools[i].length > 0) {
          var s = pools[i].pop(); moved = true;
          if (!taken[s]) { taken[s] = 1; out.push(s); break; }
        }
      }
    }
    return out;
  }
  /* 二级题型叶子（kpmap 带 p=父叶 slug）与父叶题集重叠：同一话题父子都命中薄弱/错过时只留更具体的子叶（most-specific-wins，docs/plan-r528） */
  function dropParents(list) {
    var has = {}; list.forEach(function (it) { if (it.p) has[it.p] = 1; });
    return list.filter(function (it) { return !has[it.slug]; });
  }
  /* 整卷口径低覆盖：先按蓝图节题数最大余数配额（130 卷 20/40/10/40/20 → n=10 时 2/3/1/3/1），节内再轮转；无候选的节不分额，节内不足时余额全池轮转补齐 */
  function lineCovPick(lowCov, sections, stats, want, taken) {
    var bySec = {}; var rest = [];
    lowCov.forEach(function (it) { if (typeof it.m === 'number' && sections[it.m]) (bySec[it.m] = bySec[it.m] || []).push(it); else rest.push(it); });
    var idx = Object.keys(bySec).map(Number);
    var wsum = 0; idx.forEach(function (i) { wsum += sections[i].n; });
    if (idx.length === 0 || wsum <= 0) return roundRobin(lowCov.map(function (it) { return stats[it.slug].undone; }), want, taken);
    var quota = {}; var frac = []; var used = 0;
    idx.forEach(function (i) { var x = want * sections[i].n / wsum; quota[i] = Math.floor(x); used += quota[i]; frac.push({ i: i, f: x - quota[i] }); });
    frac.sort(function (a, b) { return b.f - a.f || a.i - b.i; });
    for (var k = 0; used < want && k < frac.length; k++) { quota[frac[k].i]++; used++; }
    var out = [];
    idx.forEach(function (i) { out = out.concat(roundRobin(bySec[i].map(function (it) { return stats[it.slug].undone; }), quota[i], taken)); });
    if (out.length < want) out = out.concat(roundRobin(lowCov.map(function (it) { return stats[it.slug].undone; }), want - out.length, taken));
    return out;
  }
  function smartPick(kps, n, line) {
    var done = {}; store.readList('tiku-done').forEach(function (p) { var s = toSlug(p); if (s) done[s] = 1; });
    var wrongAll = {}; store.readList('tiku-wrong').forEach(function (p) { var s = toSlug(p); if (s) wrongAll[s] = 1; });
    var all = {}; var stats = {};
    kps.forEach(function (it) {
      var st = { total: 0, done: 0, wrong: 0, acc: 1, undone: [] };
      (it.q || []).forEach(function (s) {
        all[s] = 1; st.total++;
        if (done[s]) { st.done++; if (wrongAll[s]) st.wrong++; } else st.undone.push(s);
      });
      if (st.done > 0) st.acc = 1 - st.wrong / st.done;
      st.weak = st.done >= WEAK_MIN_DONE && st.acc < WEAK_ACC;
      stats[it.slug] = st;
    });
    var wrongSet = {}; Object.keys(wrongAll).forEach(function (s) { if (all[s]) wrongSet[s] = 1; });
    /* 到期错题：tiku-wrongt 上次复习秒 / tiku-wrongk 轮次，间隔 1/3/7 天（只读，清理由 app.js wrongDue 负责） */
    var wt = store.read('tiku-wrongt', '{}'); var wk = store.read('tiku-wrongk', '{}');
    var nowSec = Math.floor(Date.now() / 1000);
    var dueSet = {};
    Object.keys(wrongSet).forEach(function (s) {
      var p = '/q/' + s + '/'; var t = wt[p];
      var gap = REVIEW_GAPS[Math.max(0, Math.min(2, wk[p] || 0))];
      if (typeof t !== 'number' || nowSec - t >= gap) dueSet[s] = 1;
    });
    var doneOk = [];
    Object.keys(all).forEach(function (s) { if (done[s] && !wrongSet[s]) doneOk.push(s); });
    var taken = {};
    var notDue = shuffleArr(Object.keys(wrongSet).filter(function (s) { return !dueSet[s]; }));
    var wrongPick = shuffleArr(Object.keys(dueSet)).slice(0, Math.floor(n * 0.3));
    wrongPick.forEach(function (s) { taken[s] = 1; });
    var weak = dropParents(kps.filter(function (it) { return stats[it.slug].weak && stats[it.slug].undone.length > 0; }))
      .sort(function (a, b) { return stats[a.slug].acc - stats[b.slug].acc; });
    var quota = Math.min(n - wrongPick.length, Math.ceil(n * 0.4));
    var weakPick = roundRobin(weak.map(function (it) { return stats[it.slug].undone; }), quota, taken);
    var missed = dropParents(kps.filter(function (it) { var st = stats[it.slug]; return !st.weak && st.wrong > 0 && st.undone.length > 0; }))
      .sort(function (a, b) { return stats[b.slug].wrong - stats[a.slug].wrong || stats[a.slug].acc - stats[b.slug].acc; });
    var missPick = roundRobin(missed.map(function (it) { return stats[it.slug].undone; }), quota - weakPick.length, taken);
    /* 低覆盖轮转只看父叶/无父叶（子池 ⊂ 父池，重复计权无意义）；覆盖率相同（新用户全 0）先洗牌，不按 kpmap 序偏向排前的考点 */
    var lowCov = shuffleArr(kps.filter(function (it) { return !it.p && stats[it.slug].undone.length > 0; }))
      .sort(function (a, b) { return stats[a.slug].done / stats[a.slug].total - stats[b.slug].done / stats[b.slug].total; });
    var covWant = n - wrongPick.length - weakPick.length - missPick.length;
    var covPick = line && Array.isArray(line.sections)
      ? lineCovPick(lowCov, line.sections, stats, covWant, taken)
      : roundRobin(lowCov.map(function (it) { return stats[it.slug].undone; }), covWant, taken);
    var picked = wrongPick.concat(weakPick, missPick, covPick);
    if (picked.length < n) picked = picked.concat(notDue.concat(shuffleArr(doneOk)).slice(0, n - picked.length));
    var inPick = {}; weakPick.concat(missPick).forEach(function (s) { inPick[s] = 1; });
    function hit(it) { return stats[it.slug].undone.some(function (s) { return inPick[s]; }); }
    var focusWeak = weak.filter(hit);
    var focus = focusWeak.concat(missed.filter(hit)).slice(0, 3).map(function (it) { return it.slug; });
    return { slugs: shuffleArr(picked), focus: focus, weakFocus: focusWeak.length > 0 };
  }
  function startSmart(next) {
    var sp = new URLSearchParams(location.search);
    var exam = sp.get('exam') || ''; var subject = sp.get('subject') || '';
    var line = sp.get('line') === '1';
    var n = parseInt(sp.get('n') || '10', 10);
    if ([5, 10, 15, 20].indexOf(n) < 0) n = 10;
    var fallback = '?mode=custom&exam=' + encodeURIComponent(exam) + '&subject=' + encodeURIComponent(subject) + '&n=' + n;
    function go(search) {
      try { history.replaceState(null, '', location.pathname + search); } catch (_) { /* noop */ }
      /* 重写后的 URL 无 fragment：取卷串与会话键都按新 search 重算 */
      PQ = location.search;
      SKEY = 'tiku-ws:' + location.search;
      next();
    }
    if (!/^[\w-]{1,40}$/.test(exam) || !/^[\w-]{1,40}$/.test(subject)) { go(fallback); return; }
    /* <head> BOOT_JS 已按同一 URL 前置发出 kpmap（window.__wsKp，与本脚本下载并行），直接消费；用后置空 */
    var pre = window.__wsKp; window.__wsKp = null;
    (pre || fetch(kpmapUrl({ exam: exam, subject: subject, line: line })))
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (d) {
        /* 改写后的 slugs URL 同 exam/subject，报告「累计」行的 kpmap 与本次响应相同（line 仅在服务端返回 line 时保留，无蓝图时两种 URL 同为 subject 池），直接复用不再请求 */
        kpmapData = d; kpmapP = Promise.resolve(d);
        var pick = smartPick(d.kps || [], n, d.line || null);
        if (pick.slugs.length === 0) { go(fallback); return; }
        go('?mode=slugs&slugs=' + pick.slugs.join(',') + '&smart=1&exam=' + exam + '&subject=' + subject + (d.line ? '&line=1' : '') +
          (pick.focus.length > 0 ? '&focus=' + pick.focus.join(',') + (pick.weakFocus ? '' : '&fk=miss') : ''));
      })
      .catch(function () { go(fallback); });
  }

  function start() {
    var saved = readSession();
    /* 会话只在带整卷负载且题数一致时可信；无负载时题面可能已换（随机卷），作答记录作废重新开始 */
    var payloadOk = Boolean(saved && Array.isArray(saved.ans) && saved.payload && saved.payload.meta &&
      Array.isArray(saved.payload.questions) && saved.payload.questions.length === saved.ans.length);
    /* 随机/自定义组卷与客户端错题/复习/历史重刷队列（mode=slugs）已交卷后，从入口链接再次进入（navigate，非刷新/后退）应开新卷而不是回放旧报告；固定卷同 URL 即同卷，仍回放 */
    var navEntry = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    var regenMode = /^(random|custom|slugs)$/.test(new URLSearchParams(location.search).get('mode') || '');
    if (payloadOk && saved.submitted && regenMode && navEntry && navEntry.type === 'navigate') {
      try { sessionStorage.removeItem(SKEY); } catch (_) { /* noop */ }
      payloadOk = false;
    }
    if (payloadOk) {
      ws.i = saved.i || 0; ws.ans = saved.ans; ws.start = saved.start || Date.now();
      ws.end = saved.end || 0; ws.submitted = Boolean(saved.submitted); ws.hist = saved.hist ? 1 : 0; ws.used = saved.used || 0;
      ws.po = saved.po || 0; ws.pa = saved.pa || 0;
      /* 自动暂停的会话：可见状态下恢复时直接续跑，不留遮罩 */
      if (ws.pa && saved.ap && !document.hidden) { ws.po = (ws.po || 0) + (Date.now() - ws.pa); ws.pa = 0; }
      ws.ps = saved.ps ? 1 : 0; ws.psr = saved.psr || null;
      ws.air = typeof saved.air === 'string' ? saved.air : '';
      ws.to = saved.to ? 1 : 0;
      ws.rf = typeof saved.rf === 'string' ? saved.rf : '';
      ws.qsd = Array.isArray(saved.qsd) ? saved.qsd : null;
      ws.mk = Array.isArray(saved.mk) ? saved.mk : [];
      ws.ex = Array.isArray(saved.ex) ? saved.ex : [];
      ws.cb = saved.cb || 0;
        ws.cbm = saved.cbm || 0;
      ws.pavg = saved.pavg || 0; ws.pavgn = saved.pavgn || 0;
      ws.qt = Array.isArray(saved.qt) ? saved.qt : [];
      sessPayload = saved.payload;
      boot(saved.payload, true);
    } else {
      /* 首访无会话时 <head> BOOT_JS 已先发同 URL 取卷请求（window.__wsPre，与本脚本下载并行），直接消费；用后置空避免重开新卷时复用旧响应 */
      var pre = window.__wsPre; window.__wsPre = null;
      (pre || fetch('/api/paper' + PQ))
        .then(function (r) {
          if (r.ok) return r.json();
          return r.json().catch(function () { return {}; }).then(function (d) { throw new Error(d && d.error ? String(d.error) : 'http ' + r.status); });
        })
        .then(function (d) { boot(d, false); })
        .catch(function (err) {
          $('ws-loading').remove();
          var msg = $('ws-error-msg');
          if (msg && err && err.message && !/^http /.test(err.message)) msg.textContent = '组卷失败：' + err.message + '。';
          $('ws-error').classList.remove('hidden');
        });
    }
  }
  if (/[?&]mode=smart(&|$)/.test(location.search)) startSmart(start); else start();

  /* 暂停：计时冻结、题卡遮罩、底栏隐藏；状态随会话持久化，刷新恢复仍暂停 */
  var pauseMask; /* 仅声明：上方 start() 同步恢复暂停会话时可能已创建遮罩 */
  function paintPause() {
    var paused = ws.pa > 0;
    $('ws-pause').textContent = paused ? '继续' : '暂停';
    $('ws-pause').setAttribute('aria-pressed', paused ? 'true' : 'false');
    var card = $('ws-qcard');
    card.classList.toggle('hidden', paused);
    $('ws-nav').classList.toggle('hidden', paused);
    paintSide();
    if (paused && !pauseMask) {
      pauseMask = el('div', 'mt-4 flex flex-col items-center justify-center gap-3 rounded-2xl border border-line bg-white p-10 text-center shadow-sm');
      pauseMask.id = 'ws-pause-mask';
      pauseMask.appendChild(el('p', 'text-lg font-semibold', '已暂停'));
      pauseMask.appendChild(el('p', 'text-sm text-muted', '计时已停止，题目已遮罩，休息一下吧。'));
      var btn = el('button', 'mt-1 inline-flex h-11 items-center justify-center rounded-xl bg-brand-700 px-6 text-sm font-medium text-white hover:bg-brand-800', '继续练习');
      btn.type = 'button';
      btn.addEventListener('click', function () { autoPaused = false; togglePause(); });
      pauseMask.appendChild(btn);
      card.parentNode.insertBefore(pauseMask, card.nextSibling);
      btn.focus();
    } else if (!paused) {
      var stale = pauseMask || $('ws-pause-mask');
      if (stale) stale.remove();
      pauseMask = null;
    }
  }
  function togglePause() {
    if (ws.end || ws.submitted || qs.length === 0) return;
    if (ws.pa) { ws.po = (ws.po || 0) + (Date.now() - ws.pa); ws.pa = 0; qtEnter = Date.now(); }
    else { flushQt(); ws.pa = Date.now(); $('ws-sheet-panel').hidden = true; $('ws-sheet-btn').setAttribute('aria-expanded', 'false'); }
    saveSession(); paintPause();
    if (!timerStop) paintTimer($('ws-timer'));
    var live = $('ws-timer-live');
    if (live) { live.textContent = ''; live.textContent = ws.pa ? '已暂停，计时停止' : '已继续'; }
  }
  $('ws-pause').addEventListener('click', function () { autoPaused = false; togglePause(); });
  /* 切后台自动暂停（仅非限时，回前台自动继续；手动暂停不被自动恢复） */
  var autoPaused = false;
  document.addEventListener('visibilitychange', function () {
    if (ws.end || ws.submitted || qs.length === 0) return;
    if (document.hidden) {
      if (!ws.pa) { autoPaused = true; togglePause(); }
    } else if (autoPaused && ws.pa) {
      autoPaused = false; togglePause();
    }
  });
  $('ws-prev').addEventListener('click', function () { if (ws.i > 0) { ws.i--; saveSession(); renderQ(true); paintSheet(); } });
  $('ws-next').addEventListener('click', function () { if (ws.i < qs.length - 1) { ws.i++; saveSession(); renderQ(true); paintSheet(); } });
  $('ws-submit').addEventListener('click', function () { if (reviewing) { exitReview(); return; } submitPaper(false); });
  /* 题卡左右滑动切题（横向位移 ≥60px 且明显大于纵向，避免与滚动/长按选择冲突） */
  (function () {
    var qcard = $('ws-qcard'); if (!qcard) return;
    var sx = 0, sy = 0, tracking = false;
    qcard.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    qcard.addEventListener('touchend', function (e) {
      if (!tracking || e.changedTouches.length !== 1) return;
      tracking = false;
      var sel = window.getSelection && window.getSelection();
      if (sel && String(sel).length > 0) return;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) < 60 || Math.abs(dx) <= 2 * Math.abs(dy)) return;
      if (dx < 0) $('ws-next').click(); else $('ws-prev').click();
    }, { passive: true });
  })();
  $('ws-sheet-btn').addEventListener('click', function () {
    var panel = $('ws-sheet-panel');
    var open = panel.hidden;
    if (open) paintSheet();
    panel.hidden = !open;
    $('ws-sheet-btn').setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) return;
    /* 抽屉在 DOM 里位于按钮之前：打开后把焦点移到当前题格，键盘 / 读屏才顺序可达（Esc 还给按钮） */
    var curEl = $('ws-sheet-grid').querySelector('[aria-current]') || $('ws-sheet-grid').querySelector('button');
    if (curEl) curEl.focus();
  });
  /* 答题卡格 roving tabindex（APG grid）：只有当前格是 Tab 停靠点，方向键 / Home / End 在格间移焦（不切题、不环绕、不冒泡到全局 ←→ 切题），Enter / 空格仍走 click 选题 */
  $('ws-sheet-grid').addEventListener('keydown', function (e) {
    var grid = $('ws-sheet-grid');
    var cells = Array.prototype.slice.call(grid.querySelectorAll('button'));
    var idx = cells.indexOf(document.activeElement);
    if (idx < 0 || cells.length < 2) return;
    var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').length || 1;
    var to;
    if (e.key === 'ArrowRight') to = idx + 1;
    else if (e.key === 'ArrowLeft') to = idx - 1;
    else if (e.key === 'ArrowDown') to = idx + cols;
    else if (e.key === 'ArrowUp') to = idx - cols;
    else if (e.key === 'Home') to = 0;
    else if (e.key === 'End') to = cells.length - 1;
    else return;
    e.preventDefault(); e.stopPropagation();
    to = Math.max(0, Math.min(cells.length - 1, to));
    if (to === idx) return;
    cells[idx].tabIndex = -1; cells[to].tabIndex = 0; cells[to].focus();
  });
  $('ws-mark').addEventListener('click', function () {
    if (qs.length === 0) return;
    ws.mk[ws.i] = ws.mk[ws.i] === 1 ? 0 : 1;
    saveSession(); paintMark(); paintSheet();
  });
  $('ws-fav').addEventListener('click', function () {
    if (qs.length === 0) return;
    var p = '/q/' + qs[ws.i].slug + '/';
    var favs = store.readList('tiku-fav'); var i = favs.indexOf(p);
    if (i >= 0) favs.splice(i, 1); else favs.push(p);
    store.write('tiku-fav', favs);
    paintFav();
  });
  /* 字号三档循环：标准/大/特大，作用于题干/选项/解析正文，偏好随 tiku-font 持久化；类挂 <html>（与 BOOT_JS 首帧预挂载、/q/ 单题页同一处） */
  function applyFont() {
    document.documentElement.classList.toggle('ws-font-1', fontLv === 1);
    document.documentElement.classList.toggle('ws-font-2', fontLv === 2);
    var names = ['标准', '大', '特大'];
    $('ws-font').textContent = 'A 字号 · ' + names[fontLv];
    $('ws-font').setAttribute('aria-label', '切换字号，当前' + names[fontLv]);
  }
  $('ws-font').addEventListener('click', function () {
    fontLv = (fontLv + 1) % 3;
    store.write('tiku-font', fontLv);
    applyFont();
  });
  applyFont();
  /* 夜间模式：<html> 挂 ws-dark（仅 /practice/），偏好随 tiku-dark 持久化 */
  function applyDark() {
    document.documentElement.classList.toggle('ws-dark', darkOn);
    var ico = $('ws-dark-ico'); var lbl = $('ws-dark-lbl');
    if (ico && lbl) { ico.textContent = darkOn ? '☀︎' : '☾'; lbl.textContent = darkOn ? '日间' : '夜间'; }
    else $('ws-dark-btn').textContent = darkOn ? '☀︎ 日间' : '☾ 夜间';
    $('ws-dark-btn').setAttribute('aria-pressed', darkOn ? 'true' : 'false');
  }
  $('ws-dark-btn').addEventListener('click', function () {
    darkOn = !darkOn;
    store.write('tiku-dark', darkOn ? 1 : 0);
    applyDark();
  });
  applyDark();
  $('ws-auto').checked = autoNext;
  $('ws-auto').addEventListener('change', function (e) {
    autoNext = e.target.checked;
    store.write('tiku-auto', autoNext ? 1 : 0);
  });
  $('ws-browse').checked = browse;
  $('ws-browse').addEventListener('change', function (e) {
    browse = e.target.checked;
    store.write('tiku-browse', browse ? 1 : 0);
    if (qs.length > 0 && !ws.submitted) { renderQ(); paintSheet(); }
  });
  var shufEl = $('ws-shufopt');
  if (shufEl) {
    shufEl.checked = optShuf;
    shufEl.addEventListener('change', function (e) {
      optShuf = e.target.checked;
      store.write('tiku-shufopt', optShuf ? 1 : 0);
      if (qs.length > 0) renderQ();
    });
  }
  $('ws-defer').checked = defer;
  $('ws-defer').addEventListener('change', function (e) {
    defer = e.target.checked;
    store.write('tiku-defer', defer ? 1 : 0);
    if (qs.length > 0 && !ws.submitted) { renderQ(); paintSheet(); }
  });
  /* 操作说明面板：375 触屏手势 / ≥md 键盘快捷键（同一面板，段落按视口显隐） */
  var keysBtn = document.getElementById('ws-keys');
  var keysPanel = document.getElementById('ws-keys-panel');
  function toggleKeys(open) {
    if (!keysBtn || !keysPanel) return;
    var show = typeof open === 'boolean' ? open : keysPanel.hidden;
    keysPanel.hidden = !show;
    keysBtn.setAttribute('aria-expanded', show ? 'true' : 'false');
  }
  if (keysBtn) {
    keysBtn.addEventListener('click', function () { toggleKeys(); });
    document.addEventListener('click', function (e) {
      if (!keysPanel.hidden && !keysBtn.contains(e.target) && !keysPanel.contains(e.target)) toggleKeys(false);
    });
  }
  /* 做题设置面板（字号/自动下一题/背题/交卷后判分 收纳，375 头部不再换行堆叠） */
  var setBtn = document.getElementById('ws-settings');
  var setPanel = document.getElementById('ws-settings-panel');
  function toggleSettings(open) {
    if (!setBtn || !setPanel) return;
    var show = typeof open === 'boolean' ? open : setPanel.hidden;
    setPanel.hidden = !show;
    setBtn.setAttribute('aria-expanded', show ? 'true' : 'false');
  }
  if (setBtn) {
    setBtn.addEventListener('click', function () { toggleSettings(); });
    document.addEventListener('click', function (e) {
      if (!setPanel.hidden && !setBtn.contains(e.target) && !setPanel.contains(e.target)) toggleSettings(false);
    });
  }
  /* 草稿纸：全屏画布（画笔/橡皮/清空），内容随会话保留，Escape/关闭退出 */
  var scrOv = $('ws-scratch-ov');
  (function initScratch() {
    var btn = $('ws-scratch'); var cv = $('ws-scratch-cv');
    if (!btn || !scrOv || !cv) return;
    var ctx = cv.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var erase = false; var down = false; var px = 0; var py = 0;
    function size() {
      var w = Math.round(scrOv.clientWidth * dpr); var h = Math.round(scrOv.clientHeight * dpr);
      if (cv.width === w && cv.height === h) return;
      var old = null;
      if (cv.width > 0 && cv.height > 0) {
        old = document.createElement('canvas'); old.width = cv.width; old.height = cv.height;
        old.getContext('2d').drawImage(cv, 0, 0);
      }
      cv.width = w; cv.height = h;
      if (old) ctx.drawImage(old, 0, 0);
    }
    function setMode(er) {
      erase = er;
      var pen = $('ws-scr-pen'); var ers = $('ws-scr-eraser');
      pen.setAttribute('aria-pressed', er ? 'false' : 'true');
      ers.setAttribute('aria-pressed', er ? 'true' : 'false');
      pen.classList.toggle('bg-brand-50', !er); pen.classList.toggle('text-brand-700', !er); pen.classList.toggle('font-medium', !er); pen.classList.toggle('text-muted', er);
      ers.classList.toggle('bg-brand-50', er); ers.classList.toggle('text-brand-700', er); ers.classList.toggle('font-medium', er); ers.classList.toggle('text-muted', !er);
    }
    /* 墨色随夜间模式（纸面 .bg-white 在 ws-dark 下为 #151e2e）；重开时把已有笔迹整体重染，主题切换不留旧色 */
    function ink() { return document.documentElement.classList.contains('ws-dark') ? '#e2e8f0' : '#1f2937'; }
    function recolor() {
      if (!cv.width || !cv.height) return;
      ctx.globalCompositeOperation = 'source-in';
      ctx.fillStyle = ink(); ctx.fillRect(0, 0, cv.width, cv.height);
      ctx.globalCompositeOperation = 'source-over';
    }
    function toggle(show) {
      var s = typeof show === 'boolean' ? show : scrOv.hidden;
      scrOv.hidden = !s;
      btn.setAttribute('aria-pressed', s ? 'true' : 'false');
      if (s) { size(); recolor(); }
    }
    function stroke(x1, y1, x2, y2) {
      ctx.globalCompositeOperation = erase ? 'destination-out' : 'source-over';
      ctx.strokeStyle = ink(); ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      ctx.lineWidth = (erase ? 22 : 2.4) * dpr;
      ctx.beginPath(); ctx.moveTo(x1 * dpr, y1 * dpr); ctx.lineTo(x2 * dpr, y2 * dpr); ctx.stroke();
    }
    cv.addEventListener('pointerdown', function (e) {
      down = true; px = e.clientX; py = e.clientY;
      if (cv.setPointerCapture) cv.setPointerCapture(e.pointerId);
      stroke(px, py, px + 0.01, py);
      e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (!down) return;
      stroke(px, py, e.clientX, e.clientY);
      px = e.clientX; py = e.clientY;
    });
    ['pointerup', 'pointercancel'].forEach(function (n) { cv.addEventListener(n, function () { down = false; }); });
    btn.addEventListener('click', function () { toggle(); });
    $('ws-scr-close').addEventListener('click', function () { toggle(false); });
    $('ws-scr-clear').addEventListener('click', function () { ctx.clearRect(0, 0, cv.width, cv.height); });
    $('ws-scr-pen').addEventListener('click', function () { setMode(false); });
    $('ws-scr-eraser').addEventListener('click', function () { setMode(true); });
    window.addEventListener('resize', function () { if (!scrOv.hidden) size(); });
  })();

  document.addEventListener('keydown', function (e) {
    if (e.target && /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
    if (scrOv && !scrOv.hidden) { if (e.key === 'Escape') $('ws-scr-close').click(); return; }
    if (e.key === 'Escape') {
      toggleKeys(false); toggleSettings(false);
      var sheet = $('ws-sheet-panel');
      if (sheet && !sheet.hidden) { sheet.hidden = true; $('ws-sheet-btn').setAttribute('aria-expanded', 'false'); $('ws-sheet-btn').focus(); }
      return;
    }
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    if (e.key === '?') { toggleKeys(); return; }
    if (qs.length === 0 || ws.submitted) return;
    var key = e.key.toUpperCase();
    if (key === 'P') {
      if (timed()) { var tl = $('ws-timer-live'); if (tl) { tl.textContent = ''; tl.textContent = '限时模考不可暂停'; } return; }
      togglePause(); return;
    }
    if (ws.pa) return;
    if (e.shiftKey && /^[A-H]$/.test(key) && curExcl && !ws.ans[ws.i].done) { e.preventDefault(); curExcl(key); return; }
    if (!ws.ans[ws.i].done) {
      var opts = Array.prototype.slice.call(document.querySelectorAll('#ws-qcard .js-opt'));
      var byLetter = opts.filter(function (b) { return b.dataset.key === key; })[0];
      var byDigit = /^[1-9]$/.test(key) ? opts[parseInt(key, 10) - 1] : null;
      var target = byLetter || byDigit;
      if (target && !target.disabled) { target.click(); return; }
    }
    if (key === 'M') { $('ws-mark').click(); return; }
    if (e.target && e.target.closest && e.target.closest('.js-opt')) return;
    if (e.key === 'ArrowLeft') $('ws-prev').click();
    if (e.key === 'ArrowRight') $('ws-next').click();
  });

  /* 离线兜底与静态资产缓存（public/sw.js：导航 network-first，HTML 不缓存） */
  if ('serviceWorker' in navigator) navigator.serviceWorker.register('/sw.js').catch(function () { /* noop */ });
})();
